export const fakeJsonSynthese = {
	"nom_etude": "FAU Patrice Récup",
	"initial": {
		"chauffages": {
			"Fioul domestique": {
				"cef": 55878.52,
				"cep": 429.83,
				"depense": 0
			},
			"Bois dur": {
				"cef": 9822,
				"cep": 45.33,
				"depense": 0
			}
		},
		"ecssInfos": {
			"Fioul domestique": {
				"cef": 4488.81,
				"cep": 34.53,
				"depense": 399.81
			}
		},
		"energiesTotal": {
			"cef": 71329,
			"cep": 532.3,
			"depense": 5824.89
		},
		"refroidissement": {
			"cef": 0,
			"cep": 0,
			"depense": 0
		},
		"total": {
			"cef": 539.92,
			"cep": 509.69,
			"depense": 399.81
		},
		"GES_3": 146.5,
		"GES_5": 153.3,
		"parois": [
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Mur en pierre de taille et moellons\",\"55,0\",\"\",\"0,356\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 1,900 W/m².°C\"]]",
				"code": " ME1-1",
				"designation": " Bat: 1 - Mur 1",
				"descriptif": " Mur en pierre de taille et moellons épaisseur  55 cm#Mur non isolé",
				"type": " Mur extérieur (A1)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					1.67,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"SR\",\"\",\"\",\"0,295\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,299 W/m².°C\"]]",
				"code": " 02",
				"designation": " SR",
				"type": " Plafond extérieur (A3)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2.299,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Dalle de béton\",\"\",\"\",\"0,290\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
				"code": " Pb1-1-2",
				"designation": " Bat: 1 - Plancher ss -Sous-sol",
				"descriptif": " Dalle de béton#Plancher non isolé",
				"type": " Plancher intérieur (A4)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2,
					0.95
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Plafond sur solive bois\",\"\",\"\",\"0,300\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
				"code": " Ph1-1",
				"designation": " Bat: 1 - Combles 1",
				"descriptif": " Plafond sur solive bois#Plafond non isolé",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2,
					0.95
				]
			},
			{
				"details": "[]",
				"code": " 01",
				"designation": " combles 2",
				"descriptif": " Plafond sur solive bois#Plafond  isolé 8 cm",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi neuve ou rénovée"
			}
		],
		"vitrages": [
			{
				"Code": "1-1-1",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.5,
				"Hautm": 0.5,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 0.25,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 0.25,
				"descriptif": "Fenêtre ou porte-fenêtre n° 1 (0.5 x 0.5)"
			},
			{
				"Code": "1-1-2",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.8,
				"Hautm": 1.5,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 1.2,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 1.2,
				"descriptif": "Fenêtre ou porte-fenêtre n° 2 (0.8 x 1.5)"
			},
			{
				"Code": "1-1-3",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.92,
				"Hautm": 1.56,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 1.44,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 1.44,
				"descriptif": "Fenêtre ou porte-fenêtre n° 3 (0.92 x 1.56)"
			},
			{
				"Code": "1-1-4",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.7,
				"Hautm": 1,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 0.7,
				"descriptif": "Fenêtre ou porte-fenêtre n° 4 (0.7 x 1)"
			},
			{
				"Code": "1-1-5",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.76,
				"Hautm": 1,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 0.76,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 0.76,
				"descriptif": "Fenêtre ou porte-fenêtre n° 5 (0.76 x 1)"
			},
			{
				"Code": "1-1-6",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.92,
				"Hautm": 1.8,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 1.66,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 1.66,
				"descriptif": "Fenêtre ou porte-fenêtre n° 6 (0.92 x 1.8)"
			},
			{
				"Code": "1-1-7",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 1,
				"Hautm": 1.5,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 1.5,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 1.5,
				"descriptif": "Fenêtre ou porte-fenêtre n° 7 (1 x 1.5)"
			},
			{
				"Code": "1-1-8",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.7,
				"Hautm": 1,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 0.7,
				"descriptif": "Fenêtre ou porte-fenêtre n° 8 (0.7 x 1)"
			},
			{
				"Code": "1-1-9",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 1.2,
				"Hautm": 1.7,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 2.04,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 2.04,
				"descriptif": "Fenêtre ou porte-fenêtre n° 9 (1.2 x 1.7)"
			},
			{
				"Code": "1-1-10",
				"Désignation": " Bat : 1 - Fenêtre",
				"Longm": 0.8,
				"Hautm": 1,
				"TypeOuvrant": "Fenêtre PVC",
				"TypeVitre": "Double 6mm",
				"TypeFermeture": "Sans fermeture",
				"": "",
				"Surf.m²": 0.8,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"surface": 0.8,
				"descriptif": "Fenêtre ou porte-fenêtre n° 10 (0.8 x 1)"
			},
			{
				"Code": "P1-1-1",
				"Désignation": " Bat : 1 - Porte n°1",
				"Longm": 0.84,
				"Hautm": 1.94,
				"TypeOuvrant": "Porte Bois",
				"TypeVitre": "",
				"TypeFermeture": "",
				"": "",
				"Surf.m²": 1.63,
				"Uw": 1.5,
				"Ujn": 1.5,
				"LinéiquesAppui": 0.18,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0,
				"Facteurs SolairesHiv.nu": 0,
				"Eté Pr.": 0,
				"surface": 1.63,
				"descriptif": "Porte n° 1 (0.84 x 1.94)"
			}
		],
		"vitragesCaracs": [
			{
				"Code": "1-1-1",
				"Surf.m²": 0.25,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-2",
				"Surf.m²": 1.2,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-3",
				"Surf.m²": 1.44,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-4",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-5",
				"Surf.m²": 0.76,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-6",
				"Surf.m²": 1.66,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-7",
				"Surf.m²": 1.5,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-8",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-9",
				"Surf.m²": 2.04,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-10",
				"Surf.m²": 0.8,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "P1-1-1",
				"Surf.m²": 1.63,
				"Uw": 1.5,
				"Ujn": 1.5,
				"LinéiquesAppui": 0.18,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0,
				"Facteurs SolairesHiv.nu": 0,
				"Eté Pr.": 0,
				"": ""
			}
		],
		"coefUbat": [
			{
				"Désignation": "Mur extérieur",
				"Code": "ME1-1",
				"Nb": "",
				"UW/m².°C": 1.67,
				"b": 1,
				"Surfacem²": 47.54,
				"Orie": "Nord",
				"Déperd.W/°C": 79.392,
				"Réf.": "A1",
				"": ""
			},
			{
				"Désignation": "Vitrage 1",
				"Code": "1-1-1",
				"Nb": 2,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 0.5,
				"Orie": "Nord",
				"Déperd.W/°C": 2.62,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 2",
				"Code": "1-1-2",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 1.2,
				"Orie": "Nord",
				"Déperd.W/°C": 4.888,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Mur extérieur",
				"Code": "ME1-1",
				"Nb": "",
				"UW/m².°C": 1.67,
				"b": 1,
				"Surfacem²": 51.2,
				"Orie": "Est",
				"Déperd.W/°C": 85.511,
				"Réf.": "A1",
				"": ""
			},
			{
				"Désignation": "Vitrage 1",
				"Code": "1-1-6",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 1.66,
				"Orie": "Est",
				"Déperd.W/°C": 6.491,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 2",
				"Code": "1-1-7",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 1.5,
				"Orie": "Est",
				"Déperd.W/°C": 5.9,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 3",
				"Code": "1-1-8",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 0.7,
				"Orie": "Est",
				"Déperd.W/°C": 3.052,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 4",
				"Code": "1-1-9",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 2.04,
				"Orie": "Est",
				"Déperd.W/°C": 7.744,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 5",
				"Code": "1-1-10",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 0.8,
				"Orie": "Est",
				"Déperd.W/°C": 3.408,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Mur extérieur",
				"Code": "ME1-1",
				"Nb": "",
				"UW/m².°C": 1.67,
				"b": 1,
				"Surfacem²": 13.24,
				"Orie": "Sud",
				"Déperd.W/°C": 22.111,
				"Réf.": "A1",
				"": ""
			},
			{
				"Désignation": "Porte 1",
				"Code": "P1-1-1",
				"Nb": 1,
				"UW/m².°C": 1.5,
				"b": 1,
				"Surfacem²": 1.63,
				"Orie": "Sud",
				"Déperd.W/°C": 2.954,
				"Réf.": "A5",
				"": ""
			},
			{
				"Désignation": "Mur extérieur",
				"Code": "ME1-1",
				"Nb": "",
				"UW/m².°C": 1.67,
				"b": 1,
				"Surfacem²": 90.25,
				"Orie": "Oue",
				"Déperd.W/°C": 150.726,
				"Réf.": "A1",
				"": ""
			},
			{
				"Désignation": "Vitrage 1",
				"Code": "1-1-3",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 1.44,
				"Orie": "Oue",
				"Déperd.W/°C": 5.694,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 2",
				"Code": "1-1-4",
				"Nb": 1,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 0.7,
				"Orie": "Oue",
				"Déperd.W/°C": 3.052,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Vitrage 3",
				"Code": "1-1-5",
				"Nb": 2,
				"UW/m².°C": 3,
				"b": 1,
				"Surfacem²": 1.52,
				"Orie": "Oue",
				"Déperd.W/°C": 6.531,
				"Réf.": "A7",
				"": ""
			},
			{
				"Désignation": "Plafond",
				"Code": "Ph1-1",
				"Nb": "",
				"UW/m².°C": 2,
				"b": 0.95,
				"Surfacem²": 115,
				"Orie": "Int.",
				"Déperd.W/°C": 218.5,
				"Réf.": "A2",
				"": ""
			},
			{
				"Désignation": "Plafond",
				"Code": 1,
				"Nb": "",
				"UW/m².°C": 1.12,
				"b": 1,
				"Surfacem²": 15,
				"Orie": "Int.",
				"Déperd.W/°C": 16.8,
				"Réf.": "A2",
				"": ""
			},
			{
				"Désignation": "Plafond",
				"Code": 2,
				"Nb": "",
				"UW/m².°C": 2.299,
				"b": 1,
				"Surfacem²": 83.25,
				"Orie": "Nord",
				"Déperd.W/°C": 191.392,
				"Réf.": "A3",
				"": ""
			},
			{
				"Désignation": "Plafond",
				"Code": 2,
				"Nb": "",
				"UW/m².°C": 2.299,
				"b": 1,
				"Surfacem²": 83.25,
				"Orie": "Sud",
				"Déperd.W/°C": 191.392,
				"Réf.": "A3",
				"": ""
			},
			{
				"Désignation": "Plancher",
				"Code": "Pb1-1-2",
				"Nb": "",
				"UW/m².°C": 2,
				"b": 0.95,
				"Surfacem²": 124,
				"Orie": "",
				"Déperd.W/°C": 235.6,
				"Réf.": "A4",
				"": ""
			},
			{
				"Désignation": "P th. Angle de 2 murs",
				"Code": "1-01",
				"Nb": "",
				"UW/m².°C": 0.07,
				"b": 1,
				"Surfacem²": 10,
				"Orie": "",
				"Déperd.W/°C": 0.7,
				"Réf.": "",
				"": ""
			},
			{
				"Désignation": "P th. Mur ext./Plancher",
				"Code": "1-03",
				"Nb": "",
				"UW/m².°C": 0.28,
				"b": 1,
				"Surfacem²": 30,
				"Orie": "",
				"Déperd.W/°C": 8.4,
				"Réf.": "L8",
				"": ""
			},
			{
				"Désignation": "P th. Mur ext./Plaf. combles",
				"Code": "1-05",
				"Nb": "",
				"UW/m².°C": 0.05,
				"b": 1,
				"Surfacem²": 30,
				"Orie": "",
				"Déperd.W/°C": 1.5,
				"Réf.": "",
				"": ""
			}
		],
		"coefUbatObj": {
			"Déperditions Parois Extérieures": "HD : 783,46 W/°C",
			"Déperditions Parois Intérieures": "HU : 235,30 W/°C",
			"Déperditions par le sol": "HS : 235,60 W/°C",
			"Surface Totale des parois déperditives": "AT : 636,42 m²",
			"Surface des parois ext. hors plancher": "      : 512,42 m²",
			"Surface du bâtiment": "      : 130,0 m²",
			"COEFFICIENT UBAT": "1,971",
			"Ventilation spécifique": "      : 88,40 W/°C",
			"Infiltrations": "      : 16,79 W/°C",
			"Total (GV)": "      : 1359,55 W/°C",
			"Déperditions totales (sans majoration)": "      : 38,07 kW"
		},
		"totaux": {
			"bilanEnergetique": "Bilan CO2",
			"MWhEP": 69.2,
			"tonnes": 19.929,
			"kWhEP": 532.32,
			"kg": 153.3
		},
		"etiquette": {
			"Consommation": "585,6 KWhEP/m².an",
			"Emission de GES": "146,5 kgéqCO2/m².an",
			"Méthode 3CL 2021": "Moteur TRIBU V1_4_25.1"
		},
		"depense": {
			"type": "en ?",
			"totalDepenseAnnuel": 5906.15
		},
		"analyseFinanciere": {
			"Investissement": "11217 ?",
			"Durée de l'ECO prêt": "0,00 ans",
			"Primes et aides": "0 ?",
			"Taux d'intérêt de l'ECO prêt": "0,00 %",
			"MaPrimeRénov'": "0 ?",
			"Durée de l'emprunt comp.": "0,00 ans",
			"Taux d'intérêt de l'emprunt comp.": "0,00 %",
			"Apport": "0 ?",
			"ECO Prêt  (maxi : 50000 )": "0 ?",
			"Remboursement mensuel": "0 ?",
			"costs": {
				"total": {
					"avant": "284198 ?",
					"apres": "75482 ?",
					"economies": "208716 ?"
				},
				"annuel": {
					"avant": "9473 ?/an",
					"apres": "2516 ?/an",
					"economies": "6957 ?/an"
				}
			},
			"arrFinanciere": [
				{
					"Année": 0,
					"Avant travaux Entretien et Abonnements": 0,
					"Conso.": 0,
					"Investis. Après travaux hors emprunt": 11217,
					"Annuité emprunt": 0,
					"Conso. Elec.": 0,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 0,
					"Total": 11217,
					"Economie": -11217,
					"": ""
				},
				{
					"Année": 1,
					"Avant travaux Entretien et Abonnements": 81,
					"Conso.": 5825,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 909,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 81,
					"Total": 990,
					"Economie": 4916,
					"": ""
				},
				{
					"Année": 2,
					"Avant travaux Entretien et Abonnements": 84,
					"Conso.": 6003,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 955,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 84,
					"Total": 1038,
					"Economie": 5048,
					"": ""
				},
				{
					"Année": 3,
					"Avant travaux Entretien et Abonnements": 86,
					"Conso.": 6187,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1002,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 86,
					"Total": 1088,
					"Economie": 5184,
					"": ""
				},
				{
					"Année": 4,
					"Avant travaux Entretien et Abonnements": 89,
					"Conso.": 6376,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1052,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 89,
					"Total": 1141,
					"Economie": 5324,
					"": ""
				},
				{
					"Année": 5,
					"Avant travaux Entretien et Abonnements": 91,
					"Conso.": 6571,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1105,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 91,
					"Total": 1196,
					"Economie": 5466,
					"": ""
				},
				{
					"Année": 6,
					"Avant travaux Entretien et Abonnements": 94,
					"Conso.": 6773,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1160,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 94,
					"Total": 1254,
					"Economie": 5612,
					"": ""
				},
				{
					"Année": 7,
					"Avant travaux Entretien et Abonnements": 97,
					"Conso.": 6980,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1218,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 97,
					"Total": 1315,
					"Economie": 5762,
					"": ""
				},
				{
					"Année": 8,
					"Avant travaux Entretien et Abonnements": 100,
					"Conso.": 7194,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1279,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 100,
					"Total": 1379,
					"Economie": 5915,
					"": ""
				},
				{
					"Année": 9,
					"Avant travaux Entretien et Abonnements": 103,
					"Conso.": 7415,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1343,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 103,
					"Total": 1446,
					"Economie": 6072,
					"": ""
				},
				{
					"Année": 10,
					"Avant travaux Entretien et Abonnements": 106,
					"Conso.": 7642,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1410,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 106,
					"Total": 1516,
					"Economie": 6232,
					"": ""
				},
				{
					"Année": 11,
					"Avant travaux Entretien et Abonnements": 109,
					"Conso.": 7877,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1481,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 109,
					"Total": 1590,
					"Economie": 6396,
					"": ""
				},
				{
					"Année": 12,
					"Avant travaux Entretien et Abonnements": 112,
					"Conso.": 8119,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1555,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 112,
					"Total": 1667,
					"Economie": 6564,
					"": ""
				},
				{
					"Année": 13,
					"Avant travaux Entretien et Abonnements": 116,
					"Conso.": 8368,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1633,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 116,
					"Total": 1748,
					"Economie": 6735,
					"": ""
				},
				{
					"Année": 14,
					"Avant travaux Entretien et Abonnements": 119,
					"Conso.": 8625,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1714,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 119,
					"Total": 1834,
					"Economie": 6911,
					"": ""
				},
				{
					"Année": 15,
					"Avant travaux Entretien et Abonnements": 123,
					"Conso.": 8890,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1800,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 123,
					"Total": 1923,
					"Economie": 7090,
					"": ""
				},
				{
					"Année": 16,
					"Avant travaux Entretien et Abonnements": 127,
					"Conso.": 9164,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1890,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 127,
					"Total": 2017,
					"Economie": 7274,
					"": ""
				},
				{
					"Année": 17,
					"Avant travaux Entretien et Abonnements": 130,
					"Conso.": 9446,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1984,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 130,
					"Total": 2115,
					"Economie": 7461,
					"": ""
				},
				{
					"Année": 18,
					"Avant travaux Entretien et Abonnements": 134,
					"Conso.": 9736,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2084,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 134,
					"Total": 2218,
					"Economie": 7653,
					"": ""
				},
				{
					"Année": 19,
					"Avant travaux Entretien et Abonnements": 138,
					"Conso.": 10036,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2188,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 138,
					"Total": 2326,
					"Economie": 7848,
					"": ""
				},
				{
					"Année": 20,
					"Avant travaux Entretien et Abonnements": 142,
					"Conso.": 10346,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2297,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 142,
					"Total": 2440,
					"Economie": 8048,
					"": ""
				},
				{
					"Année": 21,
					"Avant travaux Entretien et Abonnements": 147,
					"Conso.": 10665,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2412,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 147,
					"Total": 2559,
					"Economie": 8252,
					"": ""
				},
				{
					"Année": 22,
					"Avant travaux Entretien et Abonnements": 151,
					"Conso.": 10994,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2533,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 151,
					"Total": 2684,
					"Economie": 8461,
					"": ""
				},
				{
					"Année": 23,
					"Avant travaux Entretien et Abonnements": 156,
					"Conso.": 11333,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2659,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 156,
					"Total": 2815,
					"Economie": 8673,
					"": ""
				},
				{
					"Année": 24,
					"Avant travaux Entretien et Abonnements": 160,
					"Conso.": 11683,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2792,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 160,
					"Total": 2953,
					"Economie": 8890,
					"": ""
				},
				{
					"Année": 25,
					"Avant travaux Entretien et Abonnements": 165,
					"Conso.": 12044,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2932,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 165,
					"Total": 3097,
					"Economie": 9112,
					"": ""
				},
				{
					"Année": 26,
					"Avant travaux Entretien et Abonnements": 170,
					"Conso.": 12416,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3079,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 170,
					"Total": 3249,
					"Economie": 9337,
					"": ""
				},
				{
					"Année": 27,
					"Avant travaux Entretien et Abonnements": 175,
					"Conso.": 12800,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3232,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 175,
					"Total": 3408,
					"Economie": 9568,
					"": ""
				},
				{
					"Année": 28,
					"Avant travaux Entretien et Abonnements": 181,
					"Conso.": 13196,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3394,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 181,
					"Total": 3575,
					"Economie": 9802,
					"": ""
				},
				{
					"Année": 29,
					"Avant travaux Entretien et Abonnements": 186,
					"Conso.": 13605,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3564,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 186,
					"Total": 3750,
					"Economie": 10041,
					"": ""
				},
				{
					"Année": 30,
					"Avant travaux Entretien et Abonnements": 192,
					"Conso.": 14026,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3742,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 192,
					"Total": 3933,
					"Economie": 10284,
					"": ""
				}
			],
			"evolutionEmissionGes": {
				"Emission de CO2 avant travaux": "19 928,88 KgCO2éq/an",
				"Emission de CO2 après travaux": " 454,95 KgCO2éq/an",
				"Emission de CO2 des travaux": " 0,00 KgCO2éq/an",
				"Economie réalisée": "584 220 KgéqCo2",
				"tempsPeriode": "sur une période de 30 ans"
			},
			"tempsDeRetour": "entre 2 et 3 ans"
		},
		"energies": {
			"CHAUFFAGE": {
				"cef": 65701,
				"cep": 475,
				"depense": 5255,
				"children": {
					"Fioul domestique": {
						"cef": 55879,
						"cep": 430,
						"depense": 0
					},
					"Bois dur": {
						"cef": 9822,
						"cep": 45,
						"depense": 0
					},
					"Total dépense chauffage": {
						"cef": 0,
						"cep": 0,
						"depense": 5255
					}
				}
			},
			"REFROIDISSEMENT": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ECS": {
				"cef": 4489,
				"cep": 35,
				"depense": 400,
				"children": {
					"Fioul domestique": {
						"cef": 4489,
						"cep": 35,
						"depense": 400
					}
				}
			},
			"ECLAIRAGE": {
				"cef": 451,
				"cep": 9,
				"depense": 67
			},
			"AUXILIAIRES": {
				"cef": 688,
				"cep": 14,
				"depense": 103
			},
			"VENTILATEURS": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"AUTRES USAGES": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ABONNEMENTS EDF": {
				"cef": 0,
				"cep": 0,
				"depense": 81
			},
			"ABONNEMENTS Autres": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ENTRETIEN": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			}
		}
	},
	"sc1": {
		"chauffages": {
			"Electricité": {
				"cef": 4123.06,
				"cep": 81.83,
				"depense": 615.65
			}
		},
		"ecssInfos": {
			"Electricité": {
				"cef": 1194.47,
				"cep": 23.71,
				"depense": 178.36
			}
		},
		"energiesTotal": {
			"cef": 6088,
			"cep": 120.8,
			"depense": 909.09
		},
		"refroidissement": {
			"cef": 0,
			"cep": 0,
			"depense": 0
		},
		"total": {
			"cef": 40.9,
			"cep": 105.54,
			"depense": 794.01
		},
		"GES_3": 5,
		"GES_5": 3.5,
		"pacs": [
			{
				"type": "POMPE A CHALEUR AIR/EAU",
				"identique": 1,
				"puissance": 13,
				"cop": 4.2
			},
			{
				"type": "POELE A BOIS ANCIEN",
				"identique": 1
			}
		],
		"ecss": [
			{
				"nombre": 1,
				"title": "thermodynamique",
				"cop": 2.7
			}
		],
		"parois": [
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Mur en pierre de taille et moellons\",\"55,0\",\"\",\"0,356\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"6,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " ME1-1",
				"designation": " Bat: 1 - Mur 1",
				"descriptif": " Mur en pierre de taille et moellons épaisseur  55 cm#Mur non isolé",
				"type": " Mur extérieur (A1)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.152,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"SR\",\"\",\"\",\"0,295\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"6,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " 02",
				"designation": " SR",
				"type": " Plafond extérieur (A3)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.155,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Dalle de béton\",\"\",\"\",\"0,290\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
				"code": " Pb1-1-2",
				"designation": " Bat: 1 - Plancher ss -Sous-sol",
				"descriptif": " Dalle de béton#Plancher non isolé",
				"type": " Plancher intérieur (A4)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2,
					0.95
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Plafond sur solive bois\",\"\",\"\",\"0,300\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
				"code": " Ph1-1",
				"designation": " Bat: 1 - Combles 1",
				"descriptif": " Plafond sur solive bois#Plafond non isolé",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2,
					0.95
				]
			},
			{
				"details": "[]",
				"code": " 01",
				"designation": " combles 2",
				"descriptif": " Plafond sur solive bois#Plafond  isolé 8 cm",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi neuve ou rénovée"
			}
		],
		"vitrages": [
			{
				"CONTROLE DES ENTREESCode": "",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-1",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-2",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-3",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-4",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-5",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-6",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-7",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-8",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-9",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-10",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "P1-1-1",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			}
		],
		"vitragesCaracs": [
			{
				"Code": "1-1-1",
				"Surf.m²": 0.25,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-2",
				"Surf.m²": 1.2,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-3",
				"Surf.m²": 1.44,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-4",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-5",
				"Surf.m²": 0.76,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-6",
				"Surf.m²": 1.66,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-7",
				"Surf.m²": 1.5,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-8",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-9",
				"Surf.m²": 2.04,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-10",
				"Surf.m²": 0.8,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "P1-1-1",
				"Surf.m²": 1.63,
				"Uw": 1.5,
				"Ujn": 1.5,
				"LinéiquesAppui": 0.18,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0,
				"Facteurs SolairesHiv.nu": 0,
				"Eté Pr.": 0,
				"": ""
			}
		],
		"coefUbat": [],
		"coefUbatObj": {
			"Mur extérieur": "ME1-1",
			"Vitrage 1": "1-1-3",
			"Vitrage 2": "1-1-4",
			"Vitrage 3": "1-1-5",
			"Vitrage 4": "1-1-9",
			"Vitrage 5": "1-1-10",
			"Porte 1": "P1-1-1",
			"Plafond": "02",
			"Plancher": "Pb1-1-2",
			"P th. Angle de 2 murs": "1-01",
			"P th. Mur ext./Plancher": "1-03",
			"P th. Mur ext./Plaf. combles": "1-05"
		},
		"totaux": {
			"bilanEnergetique": "Bilan CO2",
			"MWhEP": 15.71,
			"tonnes": 455,
			"kWhEP": 120.83,
			"kg": 3.5
		},
		"etiquette": {
			"Consommation": "147,4 KWhEP/m².an",
			"Consommation initiale": "585,6 KWhEP/m².an",
			"Emission de GES": "5,0 kgéqCO2/m².an",
			"Emission de GES initiale": "146,5 kgéqCO2/m².an",
			"Méthode 3CL 2021": "Moteur TRIBU V1_4_25.1"
		},
		"depense": {
			"type": "en ?",
			"totalDepenseAnnuel": 990.36,
			"tempsDeRetour": "2,28 année(s)",
			"investissements": "11217 ?"
		},
		"analyseFinanciere": {
			"Investissement": "11217 ?",
			"Durée de l'ECO prêt": "0,00 ans",
			"Primes et aides": "0 ?",
			"Taux d'intérêt de l'ECO prêt": "0,00 %",
			"MaPrimeRénov'": "0 ?",
			"Durée de l'emprunt comp.": "0,00 ans",
			"Taux d'intérêt de l'emprunt comp.": "0,00 %",
			"Apport": "0 ?",
			"ECO Prêt  (maxi : 50000 )": "0 ?",
			"Remboursement mensuel": "0 ?",
			"costs": {
				"total": {
					"avant": "284198 ?",
					"apres": "75482 ?",
					"economies": "208716 ?"
				},
				"annuel": {
					"avant": "9473 ?/an",
					"apres": "2516 ?/an",
					"economies": "6957 ?/an"
				}
			},
			"arrFinanciere": [
				{
					"Année": 0,
					"Avant travaux Entretien et Abonnements": 0,
					"Conso.": 0,
					"Investis. Après travaux hors emprunt": 11217,
					"Annuité emprunt": 0,
					"Conso. Elec.": 0,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 0,
					"Total": 11217,
					"Economie": -11217,
					"": ""
				},
				{
					"Année": 1,
					"Avant travaux Entretien et Abonnements": 81,
					"Conso.": 5825,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 909,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 81,
					"Total": 990,
					"Economie": 4916,
					"": ""
				},
				{
					"Année": 2,
					"Avant travaux Entretien et Abonnements": 84,
					"Conso.": 6003,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 955,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 84,
					"Total": 1038,
					"Economie": 5048,
					"": ""
				},
				{
					"Année": 3,
					"Avant travaux Entretien et Abonnements": 86,
					"Conso.": 6187,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1002,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 86,
					"Total": 1088,
					"Economie": 5184,
					"": ""
				},
				{
					"Année": 4,
					"Avant travaux Entretien et Abonnements": 89,
					"Conso.": 6376,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1052,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 89,
					"Total": 1141,
					"Economie": 5324,
					"": ""
				},
				{
					"Année": 5,
					"Avant travaux Entretien et Abonnements": 91,
					"Conso.": 6571,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1105,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 91,
					"Total": 1196,
					"Economie": 5466,
					"": ""
				},
				{
					"Année": 6,
					"Avant travaux Entretien et Abonnements": 94,
					"Conso.": 6773,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1160,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 94,
					"Total": 1254,
					"Economie": 5612,
					"": ""
				},
				{
					"Année": 7,
					"Avant travaux Entretien et Abonnements": 97,
					"Conso.": 6980,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1218,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 97,
					"Total": 1315,
					"Economie": 5762,
					"": ""
				},
				{
					"Année": 8,
					"Avant travaux Entretien et Abonnements": 100,
					"Conso.": 7194,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1279,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 100,
					"Total": 1379,
					"Economie": 5915,
					"": ""
				},
				{
					"Année": 9,
					"Avant travaux Entretien et Abonnements": 103,
					"Conso.": 7415,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1343,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 103,
					"Total": 1446,
					"Economie": 6072,
					"": ""
				},
				{
					"Année": 10,
					"Avant travaux Entretien et Abonnements": 106,
					"Conso.": 7642,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1410,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 106,
					"Total": 1516,
					"Economie": 6232,
					"": ""
				},
				{
					"Année": 11,
					"Avant travaux Entretien et Abonnements": 109,
					"Conso.": 7877,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1481,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 109,
					"Total": 1590,
					"Economie": 6396,
					"": ""
				},
				{
					"Année": 12,
					"Avant travaux Entretien et Abonnements": 112,
					"Conso.": 8119,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1555,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 112,
					"Total": 1667,
					"Economie": 6564,
					"": ""
				},
				{
					"Année": 13,
					"Avant travaux Entretien et Abonnements": 116,
					"Conso.": 8368,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1633,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 116,
					"Total": 1748,
					"Economie": 6735,
					"": ""
				},
				{
					"Année": 14,
					"Avant travaux Entretien et Abonnements": 119,
					"Conso.": 8625,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1714,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 119,
					"Total": 1834,
					"Economie": 6911,
					"": ""
				},
				{
					"Année": 15,
					"Avant travaux Entretien et Abonnements": 123,
					"Conso.": 8890,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1800,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 123,
					"Total": 1923,
					"Economie": 7090,
					"": ""
				},
				{
					"Année": 16,
					"Avant travaux Entretien et Abonnements": 127,
					"Conso.": 9164,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1890,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 127,
					"Total": 2017,
					"Economie": 7274,
					"": ""
				},
				{
					"Année": 17,
					"Avant travaux Entretien et Abonnements": 130,
					"Conso.": 9446,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1984,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 130,
					"Total": 2115,
					"Economie": 7461,
					"": ""
				},
				{
					"Année": 18,
					"Avant travaux Entretien et Abonnements": 134,
					"Conso.": 9736,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2084,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 134,
					"Total": 2218,
					"Economie": 7653,
					"": ""
				},
				{
					"Année": 19,
					"Avant travaux Entretien et Abonnements": 138,
					"Conso.": 10036,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2188,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 138,
					"Total": 2326,
					"Economie": 7848,
					"": ""
				},
				{
					"Année": 20,
					"Avant travaux Entretien et Abonnements": 142,
					"Conso.": 10346,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2297,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 142,
					"Total": 2440,
					"Economie": 8048,
					"": ""
				},
				{
					"Année": 21,
					"Avant travaux Entretien et Abonnements": 147,
					"Conso.": 10665,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2412,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 147,
					"Total": 2559,
					"Economie": 8252,
					"": ""
				},
				{
					"Année": 22,
					"Avant travaux Entretien et Abonnements": 151,
					"Conso.": 10994,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2533,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 151,
					"Total": 2684,
					"Economie": 8461,
					"": ""
				},
				{
					"Année": 23,
					"Avant travaux Entretien et Abonnements": 156,
					"Conso.": 11333,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2659,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 156,
					"Total": 2815,
					"Economie": 8673,
					"": ""
				},
				{
					"Année": 24,
					"Avant travaux Entretien et Abonnements": 160,
					"Conso.": 11683,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2792,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 160,
					"Total": 2953,
					"Economie": 8890,
					"": ""
				},
				{
					"Année": 25,
					"Avant travaux Entretien et Abonnements": 165,
					"Conso.": 12044,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2932,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 165,
					"Total": 3097,
					"Economie": 9112,
					"": ""
				},
				{
					"Année": 26,
					"Avant travaux Entretien et Abonnements": 170,
					"Conso.": 12416,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3079,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 170,
					"Total": 3249,
					"Economie": 9337,
					"": ""
				},
				{
					"Année": 27,
					"Avant travaux Entretien et Abonnements": 175,
					"Conso.": 12800,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3232,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 175,
					"Total": 3408,
					"Economie": 9568,
					"": ""
				},
				{
					"Année": 28,
					"Avant travaux Entretien et Abonnements": 181,
					"Conso.": 13196,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3394,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 181,
					"Total": 3575,
					"Economie": 9802,
					"": ""
				},
				{
					"Année": 29,
					"Avant travaux Entretien et Abonnements": 186,
					"Conso.": 13605,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3564,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 186,
					"Total": 3750,
					"Economie": 10041,
					"": ""
				},
				{
					"Année": 30,
					"Avant travaux Entretien et Abonnements": 192,
					"Conso.": 14026,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3742,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 192,
					"Total": 3933,
					"Economie": 10284,
					"": ""
				}
			],
			"evolutionEmissionGes": {
				"Emission de CO2 avant travaux": "19 928,88 KgCO2éq/an",
				"Emission de CO2 après travaux": " 454,95 KgCO2éq/an",
				"Emission de CO2 des travaux": " 0,00 KgCO2éq/an",
				"Economie réalisée": "584 220 KgéqCo2",
				"tempsPeriode": "sur une période de 30 ans"
			},
			"tempsDeRetour": "entre 2 et 3 ans"
		},
		"energies": {
			"CHAUFFAGE": {
				"cef": 4123,
				"cep": 82,
				"depense": 616,
				"children": {
					"Electricité": {
						"cef": 4123,
						"cep": 82,
						"depense": 616
					}
				}
			},
			"REFROIDISSEMENT": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ECS": {
				"cef": 1194,
				"cep": 24,
				"depense": 178,
				"children": {
					"Electricité": {
						"cef": 1194,
						"cep": 24,
						"depense": 178
					}
				}
			},
			"ECLAIRAGE": {
				"cef": 451,
				"cep": 9,
				"depense": 67
			},
			"AUXILIAIRES": {
				"cef": 319,
				"cep": 6,
				"depense": 48
			},
			"VENTILATEURS": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"AUTRES USAGES": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ABONNEMENTS EDF": {
				"cef": 0,
				"cep": 0,
				"depense": 81
			},
			"ABONNEMENTS Autres": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ENTRETIEN": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			}
		},
		"caracteristiquesGeographiques": {
			"Zone climatique": "H2c",
			"Coefficient a": "0,90",
			"Altitude": "311 m",
			"Coefficient b": "0,00"
		},
		"conseils": [
			"Mise en place d'une pompes a chaleur AIR EAU de 13kw, COP = 4.2",
			"Mise en place d'un systéme d'ECS thermodynamique, COP >=2.7",
			"Mise en place d'une isolation thermique des sous rampants de R= 6 m2K/W (surface a isoler : 167 m2)",
			"Mise en place d'une isolation thermique des murs par l'interieur d'une surface de 203 M2 / R= 3.7m2.k /W"
		]
	},
	"sc2": {
		"chauffages": {
			"Electricité": {
				"cef": 3697.94,
				"cep": 73.39,
				"depense": 552.17
			}
		},
		"ecssInfos": {
			"Electricité": {
				"cef": 1194.47,
				"cep": 23.71,
				"depense": 178.36
			}
		},
		"energiesTotal": {
			"cef": 5639,
			"cep": 111.9,
			"depense": 842.01
		},
		"refroidissement": {
			"cef": 0,
			"cep": 0,
			"depense": 0
		},
		"total": {
			"cef": 37.63,
			"cep": 97.1,
			"depense": 730.53
		},
		"GES_3": 5.6,
		"GES_5": 3.23,
		"pacs": [
			{
				"type": "POMPE A CHALEUR AIR/EAU",
				"identique": 1,
				"puissance": 13,
				"cop": 3.6
			},
			{
				"type": "POELE A BOIS ANCIEN",
				"identique": 1
			}
		],
		"ecss": [
			{
				"nombre": 1,
				"title": "thermodynamique",
				"cop": 2.7
			}
		],
		"parois": [
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Mur en pierre de taille et moellons\",\"55,0\",\"\",\"0,356\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"6,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " ME1-1",
				"designation": " Bat: 1 - Mur 1",
				"descriptif": " Mur en pierre de taille et moellons épaisseur  55 cm#Mur non isolé",
				"type": " Mur extérieur (A1)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.152,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"SR\",\"\",\"\",\"0,295\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"9,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " 02",
				"designation": " SR",
				"type": " Plafond extérieur (A3)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.106,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Dalle de béton\",\"\",\"\",\"0,290\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
				"code": " Pb1-1-2",
				"designation": " Bat: 1 - Plancher ss -Sous-sol",
				"descriptif": " Dalle de béton#Plancher non isolé",
				"type": " Plancher intérieur (A4)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2,
					0.95
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Plafond sur solive bois\",\"\",\"\",\"0,300\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
				"code": " Ph1-1",
				"designation": " Bat: 1 - Combles 1",
				"descriptif": " Plafond sur solive bois#Plafond non isolé",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi non rénovée",
				"uRetenu": [
					2,
					0.95
				]
			},
			{
				"details": "[]",
				"code": " 01",
				"designation": " combles 2",
				"descriptif": " Plafond sur solive bois#Plafond  isolé 8 cm",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi neuve ou rénovée"
			}
		],
		"vitrages": [
			{
				"CONTROLE DES ENTREESCode": "",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-1",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-2",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-3",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-4",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-5",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-6",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-7",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-8",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-9",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-10",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "P1-1-1",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			}
		],
		"vitragesCaracs": [
			{
				"Code": "1-1-1",
				"Surf.m²": 0.25,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-2",
				"Surf.m²": 1.2,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-3",
				"Surf.m²": 1.44,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-4",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-5",
				"Surf.m²": 0.76,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-6",
				"Surf.m²": 1.66,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-7",
				"Surf.m²": 1.5,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-8",
				"Surf.m²": 0.7,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-9",
				"Surf.m²": 2.04,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-10",
				"Surf.m²": 0.8,
				"Uw": 3,
				"Ujn": 3,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "P1-1-1",
				"Surf.m²": 1.63,
				"Uw": 1.5,
				"Ujn": 1.5,
				"LinéiquesAppui": 0.18,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0,
				"Facteurs SolairesHiv.nu": 0,
				"Eté Pr.": 0,
				"": ""
			}
		],
		"coefUbat": [],
		"coefUbatObj": {
			"Mur extérieur": "ME1-1",
			"Vitrage 1": "1-1-3",
			"Vitrage 2": "1-1-4",
			"Vitrage 3": "1-1-5",
			"Vitrage 4": "1-1-9",
			"Vitrage 5": "1-1-10",
			"Porte 1": "P1-1-1",
			"Plafond": "02",
			"Plancher": "Pb1-1-2",
			"P th. Angle de 2 murs": "1-01",
			"P th. Mur ext./Plancher": "1-03",
			"P th. Mur ext./Plaf. combles": "1-05"
		},
		"totaux": {
			"bilanEnergetique": "Bilan CO2",
			"MWhEP": 14.55,
			"tonnes": 42,
			"kWhEP": 111.91,
			"kg": 3.23
		},
		"etiquette": {
			"Consommation": "167,3 KWhEP/m².an",
			"Consommation initiale": "585,6 KWhEP/m².an",
			"Emission de GES": "5,6 kgéqCO2/m².an",
			"Emission de GES initiale": "146,5 kgéqCO2/m².an",
			"Méthode 3CL 2021": "Moteur TRIBU V1_4_25.1"
		},
		"depense": {
			"type": "en ?",
			"totalDepenseAnnuel": 923.28,
			"tempsDeRetour": "2,25 année(s)",
			"investissements": "11217 ?"
		},
		"analyseFinanciere": {
			"Investissement": "11217 ?",
			"Durée de l'ECO prêt": "0,00 ans",
			"Primes et aides": "0 ?",
			"Taux d'intérêt de l'ECO prêt": "0,00 %",
			"MaPrimeRénov'": "0 ?",
			"Durée de l'emprunt comp.": "0,00 ans",
			"Taux d'intérêt de l'emprunt comp.": "0,00 %",
			"Apport": "0 ?",
			"ECO Prêt  (maxi : 0 )": "0 ?",
			"Remboursement mensuel": "0 ?",
			"costs": {
				"total": {
					"avant": "284198 ?",
					"apres": "71025 ?",
					"economies": "213173 ?"
				},
				"annuel": {
					"avant": "9473 ?/an",
					"apres": "2368 ?/an",
					"economies": "7106 ?/an"
				}
			},
			"arrFinanciere": [
				{
					"Année": 0,
					"Avant travaux Entretien et Abonnements": 0,
					"Conso.": 0,
					"Investis. Après travaux hors emprunt": 11217,
					"Annuité emprunt": 0,
					"Conso. Elec.": 0,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 0,
					"Total": 11217,
					"Economie": -11217,
					"": ""
				},
				{
					"Année": 1,
					"Avant travaux Entretien et Abonnements": 81,
					"Conso.": 5825,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 842,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 81,
					"Total": 923,
					"Economie": 4983,
					"": ""
				},
				{
					"Année": 2,
					"Avant travaux Entretien et Abonnements": 84,
					"Conso.": 6003,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 884,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 84,
					"Total": 968,
					"Economie": 5119,
					"": ""
				},
				{
					"Année": 3,
					"Avant travaux Entretien et Abonnements": 86,
					"Conso.": 6187,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 928,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 86,
					"Total": 1015,
					"Economie": 5258,
					"": ""
				},
				{
					"Année": 4,
					"Avant travaux Entretien et Abonnements": 89,
					"Conso.": 6376,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 975,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 89,
					"Total": 1064,
					"Economie": 5401,
					"": ""
				},
				{
					"Année": 5,
					"Avant travaux Entretien et Abonnements": 91,
					"Conso.": 6571,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1023,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 91,
					"Total": 1115,
					"Economie": 5548,
					"": ""
				},
				{
					"Année": 6,
					"Avant travaux Entretien et Abonnements": 94,
					"Conso.": 6773,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1075,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 94,
					"Total": 1169,
					"Economie": 5698,
					"": ""
				},
				{
					"Année": 7,
					"Avant travaux Entretien et Abonnements": 97,
					"Conso.": 6980,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1128,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 97,
					"Total": 1225,
					"Economie": 5852,
					"": ""
				},
				{
					"Année": 8,
					"Avant travaux Entretien et Abonnements": 100,
					"Conso.": 7194,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1185,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 100,
					"Total": 1285,
					"Economie": 6009,
					"": ""
				},
				{
					"Année": 9,
					"Avant travaux Entretien et Abonnements": 103,
					"Conso.": 7415,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1244,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 103,
					"Total": 1347,
					"Economie": 6171,
					"": ""
				},
				{
					"Année": 10,
					"Avant travaux Entretien et Abonnements": 106,
					"Conso.": 7642,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1306,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 106,
					"Total": 1412,
					"Economie": 6336,
					"": ""
				},
				{
					"Année": 11,
					"Avant travaux Entretien et Abonnements": 109,
					"Conso.": 7877,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1372,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 109,
					"Total": 1481,
					"Economie": 6505,
					"": ""
				},
				{
					"Année": 12,
					"Avant travaux Entretien et Abonnements": 112,
					"Conso.": 8119,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1440,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 112,
					"Total": 1553,
					"Economie": 6678,
					"": ""
				},
				{
					"Année": 13,
					"Avant travaux Entretien et Abonnements": 116,
					"Conso.": 8368,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1512,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 116,
					"Total": 1628,
					"Economie": 6856,
					"": ""
				},
				{
					"Année": 14,
					"Avant travaux Entretien et Abonnements": 119,
					"Conso.": 8625,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1588,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 119,
					"Total": 1707,
					"Economie": 7037,
					"": ""
				},
				{
					"Année": 15,
					"Avant travaux Entretien et Abonnements": 123,
					"Conso.": 8890,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1667,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 123,
					"Total": 1790,
					"Economie": 7223,
					"": ""
				},
				{
					"Année": 16,
					"Avant travaux Entretien et Abonnements": 127,
					"Conso.": 9164,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1750,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 127,
					"Total": 1877,
					"Economie": 7413,
					"": ""
				},
				{
					"Année": 17,
					"Avant travaux Entretien et Abonnements": 130,
					"Conso.": 9446,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1838,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 130,
					"Total": 1968,
					"Economie": 7608,
					"": ""
				},
				{
					"Année": 18,
					"Avant travaux Entretien et Abonnements": 134,
					"Conso.": 9736,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1930,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 134,
					"Total": 2064,
					"Economie": 7807,
					"": ""
				},
				{
					"Année": 19,
					"Avant travaux Entretien et Abonnements": 138,
					"Conso.": 10036,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2026,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 138,
					"Total": 2165,
					"Economie": 8010,
					"": ""
				},
				{
					"Année": 20,
					"Avant travaux Entretien et Abonnements": 142,
					"Conso.": 10346,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2128,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 142,
					"Total": 2270,
					"Economie": 8218,
					"": ""
				},
				{
					"Année": 21,
					"Avant travaux Entretien et Abonnements": 147,
					"Conso.": 10665,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2234,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 147,
					"Total": 2381,
					"Economie": 8430,
					"": ""
				},
				{
					"Année": 22,
					"Avant travaux Entretien et Abonnements": 151,
					"Conso.": 10994,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2346,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 151,
					"Total": 2497,
					"Economie": 8648,
					"": ""
				},
				{
					"Année": 23,
					"Avant travaux Entretien et Abonnements": 156,
					"Conso.": 11333,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2463,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 156,
					"Total": 2619,
					"Economie": 8870,
					"": ""
				},
				{
					"Année": 24,
					"Avant travaux Entretien et Abonnements": 160,
					"Conso.": 11683,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2586,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 160,
					"Total": 2747,
					"Economie": 9097,
					"": ""
				},
				{
					"Année": 25,
					"Avant travaux Entretien et Abonnements": 165,
					"Conso.": 12044,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2716,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 165,
					"Total": 2881,
					"Economie": 9328,
					"": ""
				},
				{
					"Année": 26,
					"Avant travaux Entretien et Abonnements": 170,
					"Conso.": 12416,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2851,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 170,
					"Total": 3021,
					"Economie": 9565,
					"": ""
				},
				{
					"Année": 27,
					"Avant travaux Entretien et Abonnements": 175,
					"Conso.": 12800,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 2994,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 175,
					"Total": 3169,
					"Economie": 9806,
					"": ""
				},
				{
					"Année": 28,
					"Avant travaux Entretien et Abonnements": 181,
					"Conso.": 13196,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3144,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 181,
					"Total": 3324,
					"Economie": 10052,
					"": ""
				},
				{
					"Année": 29,
					"Avant travaux Entretien et Abonnements": 186,
					"Conso.": 13605,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3301,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 186,
					"Total": 3487,
					"Economie": 10304,
					"": ""
				},
				{
					"Année": 30,
					"Avant travaux Entretien et Abonnements": 192,
					"Conso.": 14026,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 3466,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 192,
					"Total": 3657,
					"Economie": 10560,
					"": ""
				}
			],
			"evolutionEmissionGes": {
				"Emission de CO2 avant travaux": "19 928,88 KgCO2éq/an",
				"Emission de CO2 après travaux": " 419,82 KgCO2éq/an",
				"Emission de CO2 des travaux": " 0,00 KgCO2éq/an",
				"Economie réalisée": "585 270 KgéqCo2",
				"tempsPeriode": "sur une période de 30 ans"
			},
			"tempsDeRetour": "entre 2 et 3 ans"
		},
		"energies": {
			"CHAUFFAGE": {
				"cef": 3698,
				"cep": 73,
				"depense": 552,
				"children": {
					"Electricité": {
						"cef": 3698,
						"cep": 73,
						"depense": 552
					}
				}
			},
			"REFROIDISSEMENT": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ECS": {
				"cef": 1194,
				"cep": 24,
				"depense": 178,
				"children": {
					"Electricité": {
						"cef": 1194,
						"cep": 24,
						"depense": 178
					}
				}
			},
			"ECLAIRAGE": {
				"cef": 451,
				"cep": 9,
				"depense": 67
			},
			"AUXILIAIRES": {
				"cef": 295,
				"cep": 6,
				"depense": 44
			},
			"VENTILATEURS": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"AUTRES USAGES": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ABONNEMENTS EDF": {
				"cef": 0,
				"cep": 0,
				"depense": 81
			},
			"ABONNEMENTS Autres": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ENTRETIEN": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			}
		},
		"caracteristiquesGeographiques": {
			"Zone climatique": "H2c",
			"Coefficient a": "0,90",
			"Altitude": "311 m",
			"Coefficient b": "0,00"
		},
		"conseils": [
			"Mise en place d'une pompes a chaleur AIR AIR de 13kw, COP = 3.6",
			"Mise en place d'un systéme d'ECS thermodynamique, COP >=2.7",
			"Mise en place d'une isolation thermique des sous rampants de R= 6 m2K/W (surface a isoler : 167 m2)",
			"Mise en place d'une isolation thermique des murs par l'interieur d'une surface de 203 M2 / R= 3.7m2.k /W"
		]
	},
	"sc3": {
		"chauffages": {
			"Electricité": {
				"cef": 524.05,
				"cep": 10.4,
				"depense": 78.25
			}
		},
		"ecssInfos": {
			"Electricité": {
				"cef": 1194.47,
				"cep": 23.71,
				"depense": 178.36
			}
		},
		"energiesTotal": {
			"cef": 2319,
			"cep": 46,
			"depense": 346.27
		},
		"refroidissement": {
			"cef": 0,
			"cep": 0,
			"depense": 0
		},
		"total": {
			"cef": 13.22,
			"cep": 34.11,
			"depense": 256.61
		},
		"GES_3": 2.3,
		"GES_5": 1.23,
		"pacs": [
			{
				"type": "POELE A BOIS ANCIEN",
				"identique": 1
			}
		],
		"ecss": [
			{
				"nombre": 1,
				"title": "thermodynamique",
				"cop": 2.7
			}
		],
		"parois": [
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Mur en pierre de taille et moellons\",\"55,0\",\"\",\"0,356\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"3,700\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " ME1-1",
				"designation": " Bat: 1 - Mur 1",
				"descriptif": " Mur en pierre de taille et moellons épaisseur  55 cm#Mur non isolé",
				"type": " Mur extérieur (A1)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.233,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"SR\",\"\",\"\",\"0,295\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"9,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " 02",
				"designation": " SR",
				"type": " Plafond extérieur (A3)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.106,
					1
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Dalle de béton\",\"\",\"\",\"0,290\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"3,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " Pb1-1-2",
				"designation": " Bat: 1 - Plancher ss -Sous-sol",
				"descriptif": " Dalle de béton#Plancher non isolé",
				"type": " Plancher intérieur (A4)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.286,
					0.95
				]
			},
			{
				"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Plafond sur solive bois\",\"\",\"\",\"0,300\",\"100\",\"ThU\",\"\",\"\"],[\"Isolant ajouté\",\"\",\"\",\"9,000\",\"100\",\"ThU\",\"\",\"\",\"U calculé :   W/m².°C\"]]",
				"code": " Ph1-1",
				"designation": " Bat: 1 - Combles 1",
				"descriptif": " Plafond sur solive bois#Plafond non isolé",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi neuve ou rénovée",
				"uRetenu": [
					0.105,
					0.95
				]
			},
			{
				"details": "[]",
				"code": " 01",
				"designation": " combles 2",
				"descriptif": " Plafond sur solive bois#Plafond  isolé 8 cm",
				"type": " Plafond intérieur (A2)",
				"typeDeParoi": " Paroi neuve ou rénovée"
			}
		],
		"vitrages": [
			{
				"CONTROLE DES ENTREESCode": "",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-1",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-2",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-3",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-4",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-5",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-6",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-7",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-8",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-9",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "1-1-10",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			},
			{
				"CONTROLE DES ENTREESCode": "P1-1-1",
				"surface": null,
				"descriptif": "Fenêtre ou porte-fenêtre n° undefined (NaN x NaN)"
			}
		],
		"vitragesCaracs": [
			{
				"Code": "1-1-1",
				"Surf.m²": 0.25,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-2",
				"Surf.m²": 1.2,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-3",
				"Surf.m²": 1.44,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-4",
				"Surf.m²": 0.7,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-5",
				"Surf.m²": 0.76,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-6",
				"Surf.m²": 1.66,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-7",
				"Surf.m²": 1.5,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-8",
				"Surf.m²": 0.7,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-9",
				"Surf.m²": 2.04,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "1-1-10",
				"Surf.m²": 0.8,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.28,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0.42,
				"Facteurs SolairesHiv.nu": 0.42,
				"Eté Pr.": 0.12,
				"": ""
			},
			{
				"Code": "P1-1-1",
				"Surf.m²": 1.63,
				"Uw": 0.9,
				"Ujn": 0.9,
				"LinéiquesAppui": 0.18,
				"LinéiquesTabl.": 0.28,
				"Lint.": 0.28,
				"Facteurs SolairesEté nu": 0,
				"Facteurs SolairesHiv.nu": 0,
				"Eté Pr.": 0,
				"": ""
			}
		],
		"coefUbat": [],
		"coefUbatObj": {
			"Mur extérieur": "ME1-1",
			"Vitrage 1": "1-1-3",
			"Vitrage 2": "1-1-4",
			"Vitrage 3": "1-1-5",
			"Vitrage 4": "1-1-9",
			"Vitrage 5": "1-1-10",
			"Porte 1": "P1-1-1",
			"Plafond": "02",
			"Plancher": "Pb1-1-2",
			"P th. Angle de 2 murs": "1-01",
			"P th. Mur ext./Plancher": "1-03",
			"P th. Mur ext./Plaf. combles": "1-05"
		},
		"totaux": {
			"bilanEnergetique": "Bilan CO2",
			"MWhEP": 5.98,
			"tonnes": 16,
			"kWhEP": 46.02,
			"kg": 1.23
		},
		"etiquette": {
			"Consommation": "70,0 KWhEP/m².an",
			"Consommation initiale": "585,6 KWhEP/m².an",
			"Emission de GES": "2,3 kgéqCO2/m².an",
			"Emission de GES initiale": "146,5 kgéqCO2/m².an",
			"Méthode 3CL 2021": "Moteur TRIBU V1_4_25.1"
		},
		"depense": {
			"type": "en ?",
			"totalDepenseAnnuel": 427.53,
			"tempsDeRetour": "2,64 année(s)",
			"investissements": "14483 ?"
		},
		"analyseFinanciere": {
			"Investissement": "29651 ?",
			"Durée de l'ECO prêt": "0,00 ans",
			"Primes et aides": "0 ?",
			"Taux d'intérêt de l'ECO prêt": "0,00 %",
			"MaPrimeRénov'": "15168 ?",
			"Durée de l'emprunt comp.": "0,00 ans",
			"Taux d'intérêt de l'emprunt comp.": "0,00 %",
			"Apport": "0 ?",
			"ECO Prêt  (maxi : 50000 )": "0 ?",
			"Remboursement mensuel": "0 ?",
			"costs": {
				"total": {
					"avant": "284198 ?",
					"apres": "41355 ?",
					"economies": "242843 ?"
				},
				"annuel": {
					"avant": "9473 ?/an",
					"apres": "1379 ?/an",
					"economies": "8095 ?/an"
				}
			},
			"arrFinanciere": [
				{
					"Année": 0,
					"Avant travaux Entretien et Abonnements": 0,
					"Conso.": 0,
					"Investis. Après travaux hors emprunt": 14483,
					"Annuité emprunt": 0,
					"Conso. Elec.": 0,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 0,
					"Total": 14483,
					"Economie": -14483,
					"": ""
				},
				{
					"Année": 1,
					"Avant travaux Entretien et Abonnements": 81,
					"Conso.": 5825,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 346,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 81,
					"Total": 428,
					"Economie": 5479,
					"": ""
				},
				{
					"Année": 2,
					"Avant travaux Entretien et Abonnements": 84,
					"Conso.": 6003,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 364,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 84,
					"Total": 447,
					"Economie": 5639,
					"": ""
				},
				{
					"Année": 3,
					"Avant travaux Entretien et Abonnements": 86,
					"Conso.": 6187,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 382,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 86,
					"Total": 468,
					"Economie": 5805,
					"": ""
				},
				{
					"Année": 4,
					"Avant travaux Entretien et Abonnements": 89,
					"Conso.": 6376,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 401,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 89,
					"Total": 490,
					"Economie": 5975,
					"": ""
				},
				{
					"Année": 5,
					"Avant travaux Entretien et Abonnements": 91,
					"Conso.": 6571,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 421,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 91,
					"Total": 512,
					"Economie": 6150,
					"": ""
				},
				{
					"Année": 6,
					"Avant travaux Entretien et Abonnements": 94,
					"Conso.": 6773,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 442,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 94,
					"Total": 536,
					"Economie": 6331,
					"": ""
				},
				{
					"Année": 7,
					"Avant travaux Entretien et Abonnements": 97,
					"Conso.": 6980,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 464,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 97,
					"Total": 561,
					"Economie": 6516,
					"": ""
				},
				{
					"Année": 8,
					"Avant travaux Entretien et Abonnements": 100,
					"Conso.": 7194,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 487,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 100,
					"Total": 587,
					"Economie": 6707,
					"": ""
				},
				{
					"Année": 9,
					"Avant travaux Entretien et Abonnements": 103,
					"Conso.": 7415,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 512,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 103,
					"Total": 615,
					"Economie": 6903,
					"": ""
				},
				{
					"Année": 10,
					"Avant travaux Entretien et Abonnements": 106,
					"Conso.": 7642,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 537,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 106,
					"Total": 643,
					"Economie": 7105,
					"": ""
				},
				{
					"Année": 11,
					"Avant travaux Entretien et Abonnements": 109,
					"Conso.": 7877,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 564,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 109,
					"Total": 673,
					"Economie": 7313,
					"": ""
				},
				{
					"Année": 12,
					"Avant travaux Entretien et Abonnements": 112,
					"Conso.": 8119,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 592,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 112,
					"Total": 705,
					"Economie": 7526,
					"": ""
				},
				{
					"Année": 13,
					"Avant travaux Entretien et Abonnements": 116,
					"Conso.": 8368,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 622,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 116,
					"Total": 738,
					"Economie": 7746,
					"": ""
				},
				{
					"Année": 14,
					"Avant travaux Entretien et Abonnements": 119,
					"Conso.": 8625,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 653,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 119,
					"Total": 772,
					"Economie": 7972,
					"": ""
				},
				{
					"Année": 15,
					"Avant travaux Entretien et Abonnements": 123,
					"Conso.": 8890,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 686,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 123,
					"Total": 809,
					"Economie": 8205,
					"": ""
				},
				{
					"Année": 16,
					"Avant travaux Entretien et Abonnements": 127,
					"Conso.": 9164,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 720,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 127,
					"Total": 846,
					"Economie": 8444,
					"": ""
				},
				{
					"Année": 17,
					"Avant travaux Entretien et Abonnements": 130,
					"Conso.": 9446,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 756,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 130,
					"Total": 886,
					"Economie": 8690,
					"": ""
				},
				{
					"Année": 18,
					"Avant travaux Entretien et Abonnements": 134,
					"Conso.": 9736,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 794,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 134,
					"Total": 928,
					"Economie": 8943,
					"": ""
				},
				{
					"Année": 19,
					"Avant travaux Entretien et Abonnements": 138,
					"Conso.": 10036,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 833,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 138,
					"Total": 972,
					"Economie": 9203,
					"": ""
				},
				{
					"Année": 20,
					"Avant travaux Entretien et Abonnements": 142,
					"Conso.": 10346,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 875,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 142,
					"Total": 1017,
					"Economie": 9471,
					"": ""
				},
				{
					"Année": 21,
					"Avant travaux Entretien et Abonnements": 147,
					"Conso.": 10665,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 919,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 147,
					"Total": 1066,
					"Economie": 9746,
					"": ""
				},
				{
					"Année": 22,
					"Avant travaux Entretien et Abonnements": 151,
					"Conso.": 10994,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 965,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 151,
					"Total": 1116,
					"Economie": 10029,
					"": ""
				},
				{
					"Année": 23,
					"Avant travaux Entretien et Abonnements": 156,
					"Conso.": 11333,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1013,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 156,
					"Total": 1169,
					"Economie": 10320,
					"": ""
				},
				{
					"Année": 24,
					"Avant travaux Entretien et Abonnements": 160,
					"Conso.": 11683,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1064,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 160,
					"Total": 1224,
					"Economie": 10619,
					"": ""
				},
				{
					"Année": 25,
					"Avant travaux Entretien et Abonnements": 165,
					"Conso.": 12044,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1117,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 165,
					"Total": 1282,
					"Economie": 10927,
					"": ""
				},
				{
					"Année": 26,
					"Avant travaux Entretien et Abonnements": 170,
					"Conso.": 12416,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1173,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 170,
					"Total": 1343,
					"Economie": 11243,
					"": ""
				},
				{
					"Année": 27,
					"Avant travaux Entretien et Abonnements": 175,
					"Conso.": 12800,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1231,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 175,
					"Total": 1406,
					"Economie": 11569,
					"": ""
				},
				{
					"Année": 28,
					"Avant travaux Entretien et Abonnements": 181,
					"Conso.": 13196,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1293,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 181,
					"Total": 1473,
					"Economie": 11903,
					"": ""
				},
				{
					"Année": 29,
					"Avant travaux Entretien et Abonnements": 186,
					"Conso.": 13605,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1357,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 186,
					"Total": 1543,
					"Economie": 12247,
					"": ""
				},
				{
					"Année": 30,
					"Avant travaux Entretien et Abonnements": 192,
					"Conso.": 14026,
					"Investis. Après travaux hors emprunt": 0,
					"Annuité emprunt": 0,
					"Conso. Elec.": 1425,
					"Après travaux Conso. Autre": 0,
					"Entretien et Abonnements": 192,
					"Total": 1617,
					"Economie": 12601,
					"": ""
				}
			],
			"evolutionEmissionGes": {
				"Emission de CO2 avant travaux": "19 928,88 KgCO2éq/an",
				"Emission de CO2 après travaux": " 159,73 KgCO2éq/an",
				"Emission de CO2 des travaux": " 0,00 KgCO2éq/an",
				"Economie réalisée": "593 070 KgéqCo2",
				"tempsPeriode": "sur une période de 30 ans"
			},
			"tempsDeRetour": "entre 2 et 3 ans"
		},
		"energies": {
			"CHAUFFAGE": {
				"cef": 524,
				"cep": 10,
				"depense": 78,
				"children": {
					"Electricité": {
						"cef": 524,
						"cep": 10,
						"depense": 78
					}
				}
			},
			"REFROIDISSEMENT": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ECS": {
				"cef": 1194,
				"cep": 24,
				"depense": 178,
				"children": {
					"Electricité": {
						"cef": 1194,
						"cep": 24,
						"depense": 178
					}
				}
			},
			"ECLAIRAGE": {
				"cef": 451,
				"cep": 9,
				"depense": 67
			},
			"AUXILIAIRES": {
				"cef": 149,
				"cep": 3,
				"depense": 22
			},
			"VENTILATEURS": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"AUTRES USAGES": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ABONNEMENTS EDF": {
				"cef": 0,
				"cep": 0,
				"depense": 81
			},
			"ABONNEMENTS Autres": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			},
			"ENTRETIEN": {
				"cef": 0,
				"cep": 0,
				"depense": 0
			}
		},
		"caracteristiquesGeographiques": {
			"Zone climatique": "H2c",
			"Coefficient a": "0,90",
			"Altitude": "311 m",
			"Coefficient b": "0,00"
		},
		"conseils": [
			"Mise en place d'une pompes a chaleur AIR EAU de 10kw, COP = 4.2",
			"Mise en place d'un systéme d'ECS thermodynamique, COP >=2.7 Isolation thermique du plancher sous-sol d'une surface de 124 m² avec R = 3m².k/w",
			"Mise en place d'une isolation thermique des sous rampants de R= 6 m2K/W (surface a isoler : 167 m2)",
			"Mise en place d'une isolation thermique des murs par l'interieur d'une surface de 203 M2 / R= 3.7m2.k /W"
		]
	},
	"classe_energetique_3cl_situation_initiale": "G",
	"classe_energetique_3cl_5_usages_situation_initiale": "G",
	"classe_energetique_THCE_situation_initiale": "G",
	"classe_energetique_THCE_5_usages_situation_initiale": "G",
	"conso_cef_situation_initiale": "539,92",
	"conso_cep_situation_initiale": "509,69",
	"situationInitialeEnergieECS": "Fioul domestique",
	"situationInitialeEnergie": "Fioul domestique",
	"ges_situation_initiale_3": "146,50",
	"ges_situation_initiale_5": "153,30",
	"ecs_name_situation_initiale": "Fioul domestique",
	"refroidissement_situation_initiale": "0",
	"ecs_situation_initiale": "4 488,81",
	"ecs_cep_situation_initiale": "4 488,9",
	"chauffage_principal_consomation_situation_initiale": "55 877,9",
	"chauffage_principal_nom_situation_initiale": "Fioul domestique",
	"chauffage_apoint_consomation_situation_initiale": "5 892,9",
	"chauffage_apoint_nom_situation_initiale": "Bois dur",
	"chauffage_third_consomation_situation_initiale": "0",
	"chauffage_third_nom_situation_initiale": "",
	"classe_energetique_3cl_scenario_1": "B",
	"classe_energetique_3cl_5_usages_scenario_1": "C",
	"classe_energetique_THCE_scenario_1": "C",
	"classe_energetique_THCE_5_usages_scenario_1": "C",
	"conso_cef_scenario_1": "40,90",
	"conso_cep_scenario_1": "105,54",
	"gain_energetique_scenario_1": "79,29",
	"ges_scenario_1_3": "5,00",
	"ges_scenario_1_5": "3,50",
	"ecs_name_scenario_1": "Electricité",
	"refroidissement_scenario_1": "0",
	"ecs_scenario_1": "1 194,47",
	"ecs_cep_scenario_1": "3 082,3",
	"chauffage_principal_consomation_scenario_1": "10 637,9",
	"chauffage_principal_nom_scenario_1": "Electricité",
	"chauffage_apoint_consomation_scenario_1": "0",
	"chauffage_apoint_nom_scenario_1": "",
	"chauffage_third_consomation_scenario_1": "0",
	"chauffage_third_nom_scenario_1": "",
	"classe_energetique_3cl_scenario_2": "B",
	"classe_energetique_3cl_5_usages_scenario_2": "C",
	"classe_energetique_THCE_scenario_2": "C",
	"classe_energetique_THCE_5_usages_scenario_2": "C",
	"conso_cef_scenario_2": "37,63",
	"conso_cep_scenario_2": "97,10",
	"gain_energetique_scenario_2": "80,95",
	"ges_scenario_2_3": "5,60",
	"ges_scenario_2_5": "3,23",
	"ecs_name_scenario_2": "Electricité",
	"refroidissement_scenario_2": "0",
	"ecs_scenario_2": "1 194,47",
	"ecs_cep_scenario_2": "3 082,3",
	"chauffage_principal_consomation_scenario_2": "9 540,7",
	"chauffage_principal_nom_scenario_2": "Electricité",
	"chauffage_apoint_consomation_scenario_2": "0",
	"chauffage_apoint_nom_scenario_2": "",
	"chauffage_third_consomation_scenario_2": "0",
	"chauffage_third_nom_scenario_2": "",
	"classe_energetique_3cl_scenario_3": "A",
	"classe_energetique_3cl_5_usages_scenario_3": "A",
	"classe_energetique_THCE_scenario_3": "A",
	"classe_energetique_THCE_5_usages_scenario_3": "A",
	"conso_cef_scenario_3": "13,22",
	"conso_cep_scenario_3": "34,11",
	"gain_energetique_scenario_3": "93,31",
	"ges_scenario_3_3": "2,30",
	"ges_scenario_3_5": "1,23",
	"ecs_name_scenario_3": "Electricité",
	"refroidissement_scenario_3": "0",
	"ecs_scenario_3": "1 194,47",
	"ecs_cep_scenario_3": "3 082,3",
	"chauffage_principal_consomation_scenario_3": "1 352",
	"chauffage_principal_nom_scenario_3": "Electricité",
	"chauffage_apoint_consomation_scenario_3": "0",
	"chauffage_apoint_nom_scenario_3": "",
	"chauffage_third_consomation_scenario_3": "0",
	"chauffage_third_nom_scenario_3": "",
	"surface_habitable": 130,
	"zone_climatique": "H2c",
	"temperature_exterieure": "-9 °C",
	"temperature_interieure": "19 °C",
	"rendPCI100percent": "70",
	"station_meteo": "MILLAU",
	"type_batiment": "Maison individuelle",
	"annee_construction": "Avant 1948",
	"mur_ext_nord": 47.54,
	"mur_ext_est": 51.2,
	"mur_ext_sud": 13.24,
	"mur_ext_ouest": 90.25,
	"mur_ext_total": 202.23000000000002,
	"isolation_mur_exterieur": 202.23000000000002,
	"isolation_mur_interieur": 296.5,
	"plafond_total": 296.5,
	"plancher_total": 154,
	"plafond_m2": 296.5,
	"isolation_de_la_toiture": 296.5,
	"plancher_m2": 154,
	"isolation_sous_sol": 154,
	"emetteur_chauffage_a": "Chauffage seul",
	"emetteur_chauffage_b": "Radiateur ancien avec Vanne Th.",
	"parois": [
		{
			"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Mur en pierre de taille et moellons\",\"55,0\",\"\",\"0,356\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 1,900 W/m².°C\"]]",
			"code": " ME1-1",
			"designation": " Bat: 1 - Mur 1",
			"descriptif": " Mur en pierre de taille et moellons épaisseur  55 cm#Mur non isolé",
			"type": " Mur extérieur (A1)",
			"typeDeParoi": " Paroi non rénovée",
			"uRetenu": [
				1.67,
				1
			]
		},
		{
			"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"SR\",\"\",\"\",\"0,295\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,299 W/m².°C\"]]",
			"code": " 02",
			"designation": " SR",
			"type": " Plafond extérieur (A3)",
			"typeDeParoi": " Paroi non rénovée",
			"uRetenu": [
				2.299,
				1
			]
		},
		{
			"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Dalle de béton\",\"\",\"\",\"0,290\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
			"code": " Pb1-1-2",
			"designation": " Bat: 1 - Plancher ss -Sous-sol",
			"descriptif": " Dalle de béton#Plancher non isolé",
			"type": " Plancher intérieur (A4)",
			"typeDeParoi": " Paroi non rénovée",
			"uRetenu": [
				2,
				0.95
			]
		},
		{
			"details": "[[\"Désignation\",\"Epaisseur\",\"Lambda\",\"Résistance\",\"Proportion\",\"Type\",\"Numero\",\"\"],[\"\",\"cm\",\"W/m.°C\",\"m².°C/W\",\"%\",\"\",\"\",\"\"],[\"Plafond sur solive bois\",\"\",\"\",\"0,300\",\"100\",\"ThU\",\"\",\"\",\"U calculé : 2,000 W/m².°C\"]]",
			"code": " Ph1-1",
			"designation": " Bat: 1 - Combles 1",
			"descriptif": " Plafond sur solive bois#Plafond non isolé",
			"type": " Plafond intérieur (A2)",
			"typeDeParoi": " Paroi non rénovée",
			"uRetenu": [
				2,
				0.95
			]
		},
		{
			"details": "[]",
			"code": " 01",
			"designation": " combles 2",
			"descriptif": " Plafond sur solive bois#Plafond  isolé 8 cm",
			"type": " Plafond intérieur (A2)",
			"typeDeParoi": " Paroi neuve ou rénovée"
		}
	],
	"vitrages": [
		{
			"Code": "1-1-1",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.5,
			"Hautm": 0.5,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 0.25,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 0.25,
			"descriptif": "Fenêtre ou porte-fenêtre n° 1 (0.5 x 0.5)"
		},
		{
			"Code": "1-1-2",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.8,
			"Hautm": 1.5,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 1.2,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 1.2,
			"descriptif": "Fenêtre ou porte-fenêtre n° 2 (0.8 x 1.5)"
		},
		{
			"Code": "1-1-3",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.92,
			"Hautm": 1.56,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 1.44,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 1.44,
			"descriptif": "Fenêtre ou porte-fenêtre n° 3 (0.92 x 1.56)"
		},
		{
			"Code": "1-1-4",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.7,
			"Hautm": 1,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 0.7,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 0.7,
			"descriptif": "Fenêtre ou porte-fenêtre n° 4 (0.7 x 1)"
		},
		{
			"Code": "1-1-5",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.76,
			"Hautm": 1,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 0.76,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 0.76,
			"descriptif": "Fenêtre ou porte-fenêtre n° 5 (0.76 x 1)"
		},
		{
			"Code": "1-1-6",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.92,
			"Hautm": 1.8,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 1.66,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 1.66,
			"descriptif": "Fenêtre ou porte-fenêtre n° 6 (0.92 x 1.8)"
		},
		{
			"Code": "1-1-7",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 1,
			"Hautm": 1.5,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 1.5,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 1.5,
			"descriptif": "Fenêtre ou porte-fenêtre n° 7 (1 x 1.5)"
		},
		{
			"Code": "1-1-8",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.7,
			"Hautm": 1,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 0.7,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 0.7,
			"descriptif": "Fenêtre ou porte-fenêtre n° 8 (0.7 x 1)"
		},
		{
			"Code": "1-1-9",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 1.2,
			"Hautm": 1.7,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 2.04,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 2.04,
			"descriptif": "Fenêtre ou porte-fenêtre n° 9 (1.2 x 1.7)"
		},
		{
			"Code": "1-1-10",
			"Désignation": " Bat : 1 - Fenêtre",
			"Longm": 0.8,
			"Hautm": 1,
			"TypeOuvrant": "Fenêtre PVC",
			"TypeVitre": "Double 6mm",
			"TypeFermeture": "Sans fermeture",
			"": "",
			"Surf.m²": 0.8,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"surface": 0.8,
			"descriptif": "Fenêtre ou porte-fenêtre n° 10 (0.8 x 1)"
		},
		{
			"Code": "P1-1-1",
			"Désignation": " Bat : 1 - Porte n°1",
			"Longm": 0.84,
			"Hautm": 1.94,
			"TypeOuvrant": "Porte Bois",
			"TypeVitre": "",
			"TypeFermeture": "",
			"": "",
			"Surf.m²": 1.63,
			"Uw": 1.5,
			"Ujn": 1.5,
			"LinéiquesAppui": 0.18,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0,
			"Facteurs SolairesHiv.nu": 0,
			"Eté Pr.": 0,
			"surface": 1.63,
			"descriptif": "Porte n° 1 (0.84 x 1.94)"
		}
	],
	"vitragesCaracs": [
		{
			"Code": "1-1-1",
			"Surf.m²": 0.25,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-2",
			"Surf.m²": 1.2,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-3",
			"Surf.m²": 1.44,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-4",
			"Surf.m²": 0.7,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-5",
			"Surf.m²": 0.76,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-6",
			"Surf.m²": 1.66,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-7",
			"Surf.m²": 1.5,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-8",
			"Surf.m²": 0.7,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-9",
			"Surf.m²": 2.04,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "1-1-10",
			"Surf.m²": 0.8,
			"Uw": 3,
			"Ujn": 3,
			"LinéiquesAppui": 0.28,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0.42,
			"Facteurs SolairesHiv.nu": 0.42,
			"Eté Pr.": 0.12,
			"": ""
		},
		{
			"Code": "P1-1-1",
			"Surf.m²": 1.63,
			"Uw": 1.5,
			"Ujn": 1.5,
			"LinéiquesAppui": 0.18,
			"LinéiquesTabl.": 0.28,
			"Lint.": 0.28,
			"Facteurs SolairesEté nu": 0,
			"Facteurs SolairesHiv.nu": 0,
			"Eté Pr.": 0,
			"": ""
		}
	],
	"coefUbat": [
		{
			"Désignation": "Mur extérieur",
			"Code": "ME1-1",
			"Nb": "",
			"UW/m².°C": 1.67,
			"b": 1,
			"Surfacem²": 47.54,
			"Orie": "Nord",
			"Déperd.W/°C": 79.392,
			"Réf.": "A1",
			"": ""
		},
		{
			"Désignation": "Vitrage 1",
			"Code": "1-1-1",
			"Nb": 2,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 0.5,
			"Orie": "Nord",
			"Déperd.W/°C": 2.62,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 2",
			"Code": "1-1-2",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 1.2,
			"Orie": "Nord",
			"Déperd.W/°C": 4.888,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Mur extérieur",
			"Code": "ME1-1",
			"Nb": "",
			"UW/m².°C": 1.67,
			"b": 1,
			"Surfacem²": 51.2,
			"Orie": "Est",
			"Déperd.W/°C": 85.511,
			"Réf.": "A1",
			"": ""
		},
		{
			"Désignation": "Vitrage 1",
			"Code": "1-1-6",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 1.66,
			"Orie": "Est",
			"Déperd.W/°C": 6.491,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 2",
			"Code": "1-1-7",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 1.5,
			"Orie": "Est",
			"Déperd.W/°C": 5.9,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 3",
			"Code": "1-1-8",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 0.7,
			"Orie": "Est",
			"Déperd.W/°C": 3.052,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 4",
			"Code": "1-1-9",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 2.04,
			"Orie": "Est",
			"Déperd.W/°C": 7.744,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 5",
			"Code": "1-1-10",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 0.8,
			"Orie": "Est",
			"Déperd.W/°C": 3.408,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Mur extérieur",
			"Code": "ME1-1",
			"Nb": "",
			"UW/m².°C": 1.67,
			"b": 1,
			"Surfacem²": 13.24,
			"Orie": "Sud",
			"Déperd.W/°C": 22.111,
			"Réf.": "A1",
			"": ""
		},
		{
			"Désignation": "Porte 1",
			"Code": "P1-1-1",
			"Nb": 1,
			"UW/m².°C": 1.5,
			"b": 1,
			"Surfacem²": 1.63,
			"Orie": "Sud",
			"Déperd.W/°C": 2.954,
			"Réf.": "A5",
			"": ""
		},
		{
			"Désignation": "Mur extérieur",
			"Code": "ME1-1",
			"Nb": "",
			"UW/m².°C": 1.67,
			"b": 1,
			"Surfacem²": 90.25,
			"Orie": "Oue",
			"Déperd.W/°C": 150.726,
			"Réf.": "A1",
			"": ""
		},
		{
			"Désignation": "Vitrage 1",
			"Code": "1-1-3",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 1.44,
			"Orie": "Oue",
			"Déperd.W/°C": 5.694,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 2",
			"Code": "1-1-4",
			"Nb": 1,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 0.7,
			"Orie": "Oue",
			"Déperd.W/°C": 3.052,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Vitrage 3",
			"Code": "1-1-5",
			"Nb": 2,
			"UW/m².°C": 3,
			"b": 1,
			"Surfacem²": 1.52,
			"Orie": "Oue",
			"Déperd.W/°C": 6.531,
			"Réf.": "A7",
			"": ""
		},
		{
			"Désignation": "Plafond",
			"Code": "Ph1-1",
			"Nb": "",
			"UW/m².°C": 2,
			"b": 0.95,
			"Surfacem²": 115,
			"Orie": "Int.",
			"Déperd.W/°C": 218.5,
			"Réf.": "A2",
			"": ""
		},
		{
			"Désignation": "Plafond",
			"Code": 1,
			"Nb": "",
			"UW/m².°C": 1.12,
			"b": 1,
			"Surfacem²": 15,
			"Orie": "Int.",
			"Déperd.W/°C": 16.8,
			"Réf.": "A2",
			"": ""
		},
		{
			"Désignation": "Plafond",
			"Code": 2,
			"Nb": "",
			"UW/m².°C": 2.299,
			"b": 1,
			"Surfacem²": 83.25,
			"Orie": "Nord",
			"Déperd.W/°C": 191.392,
			"Réf.": "A3",
			"": ""
		},
		{
			"Désignation": "Plafond",
			"Code": 2,
			"Nb": "",
			"UW/m².°C": 2.299,
			"b": 1,
			"Surfacem²": 83.25,
			"Orie": "Sud",
			"Déperd.W/°C": 191.392,
			"Réf.": "A3",
			"": ""
		},
		{
			"Désignation": "Plancher",
			"Code": "Pb1-1-2",
			"Nb": "",
			"UW/m².°C": 2,
			"b": 0.95,
			"Surfacem²": 124,
			"Orie": "",
			"Déperd.W/°C": 235.6,
			"Réf.": "A4",
			"": ""
		},
		{
			"Désignation": "P th. Angle de 2 murs",
			"Code": "1-01",
			"Nb": "",
			"UW/m².°C": 0.07,
			"b": 1,
			"Surfacem²": 10,
			"Orie": "",
			"Déperd.W/°C": 0.7,
			"Réf.": "",
			"": ""
		},
		{
			"Désignation": "P th. Mur ext./Plancher",
			"Code": "1-03",
			"Nb": "",
			"UW/m².°C": 0.28,
			"b": 1,
			"Surfacem²": 30,
			"Orie": "",
			"Déperd.W/°C": 8.4,
			"Réf.": "L8",
			"": ""
		},
		{
			"Désignation": "P th. Mur ext./Plaf. combles",
			"Code": "1-05",
			"Nb": "",
			"UW/m².°C": 0.05,
			"b": 1,
			"Surfacem²": 30,
			"Orie": "",
			"Déperd.W/°C": 1.5,
			"Réf.": "",
			"": ""
		}
	],
	"coefUbatObj": {
		"Déperditions Parois Extérieures": "HD : 783,46 W/°C",
		"Déperditions Parois Intérieures": "HU : 235,30 W/°C",
		"Déperditions par le sol": "HS : 235,60 W/°C",
		"Surface Totale des parois déperditives": "AT : 636,42 m²",
		"Surface des parois ext. hors plancher": "      : 512,42 m²",
		"Surface du bâtiment": "      : 130,0 m²",
		"COEFFICIENT UBAT": "1,971",
		"Ventilation spécifique": "      : 88,40 W/°C",
		"Infiltrations": "      : 16,79 W/°C",
		"Total (GV)": "      : 1359,55 W/°C",
		"Déperditions totales (sans majoration)": "      : 38,07 kW"
	},
	"totaux": {
		"bilanEnergetique": "Bilan CO2",
		"MWhEP": 69.2,
		"tonnes": 19.929,
		"kWhEP": 532.32,
		"kg": 153.3
	},
	"etiquette": {
		"Consommation": "585,6 KWhEP/m².an",
		"Emission de GES": "146,5 kgéqCO2/m².an",
		"Méthode 3CL 2021": "Moteur TRIBU V1_4_25.1"
	},
	"depense": {
		"type": "en ?",
		"totalDepenseAnnuel": 5906.15
	},
	"analyseFinanciere": {
		"Investissement": "11217 ?",
		"Durée de l'ECO prêt": "0,00 ans",
		"Primes et aides": "0 ?",
		"Taux d'intérêt de l'ECO prêt": "0,00 %",
		"MaPrimeRénov'": "0 ?",
		"Durée de l'emprunt comp.": "0,00 ans",
		"Taux d'intérêt de l'emprunt comp.": "0,00 %",
		"Apport": "0 ?",
		"ECO Prêt  (maxi : 50000 )": "0 ?",
		"Remboursement mensuel": "0 ?",
		"costs": {
			"total": {
				"avant": "284198 ?",
				"apres": "75482 ?",
				"economies": "208716 ?"
			},
			"annuel": {
				"avant": "9473 ?/an",
				"apres": "2516 ?/an",
				"economies": "6957 ?/an"
			}
		},
		"arrFinanciere": [
			{
				"Année": 0,
				"Avant travaux Entretien et Abonnements": 0,
				"Conso.": 0,
				"Investis. Après travaux hors emprunt": 11217,
				"Annuité emprunt": 0,
				"Conso. Elec.": 0,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 0,
				"Total": 11217,
				"Economie": -11217,
				"": ""
			},
			{
				"Année": 1,
				"Avant travaux Entretien et Abonnements": 81,
				"Conso.": 5825,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 909,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 81,
				"Total": 990,
				"Economie": 4916,
				"": ""
			},
			{
				"Année": 2,
				"Avant travaux Entretien et Abonnements": 84,
				"Conso.": 6003,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 955,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 84,
				"Total": 1038,
				"Economie": 5048,
				"": ""
			},
			{
				"Année": 3,
				"Avant travaux Entretien et Abonnements": 86,
				"Conso.": 6187,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1002,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 86,
				"Total": 1088,
				"Economie": 5184,
				"": ""
			},
			{
				"Année": 4,
				"Avant travaux Entretien et Abonnements": 89,
				"Conso.": 6376,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1052,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 89,
				"Total": 1141,
				"Economie": 5324,
				"": ""
			},
			{
				"Année": 5,
				"Avant travaux Entretien et Abonnements": 91,
				"Conso.": 6571,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1105,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 91,
				"Total": 1196,
				"Economie": 5466,
				"": ""
			},
			{
				"Année": 6,
				"Avant travaux Entretien et Abonnements": 94,
				"Conso.": 6773,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1160,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 94,
				"Total": 1254,
				"Economie": 5612,
				"": ""
			},
			{
				"Année": 7,
				"Avant travaux Entretien et Abonnements": 97,
				"Conso.": 6980,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1218,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 97,
				"Total": 1315,
				"Economie": 5762,
				"": ""
			},
			{
				"Année": 8,
				"Avant travaux Entretien et Abonnements": 100,
				"Conso.": 7194,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1279,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 100,
				"Total": 1379,
				"Economie": 5915,
				"": ""
			},
			{
				"Année": 9,
				"Avant travaux Entretien et Abonnements": 103,
				"Conso.": 7415,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1343,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 103,
				"Total": 1446,
				"Economie": 6072,
				"": ""
			},
			{
				"Année": 10,
				"Avant travaux Entretien et Abonnements": 106,
				"Conso.": 7642,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1410,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 106,
				"Total": 1516,
				"Economie": 6232,
				"": ""
			},
			{
				"Année": 11,
				"Avant travaux Entretien et Abonnements": 109,
				"Conso.": 7877,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1481,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 109,
				"Total": 1590,
				"Economie": 6396,
				"": ""
			},
			{
				"Année": 12,
				"Avant travaux Entretien et Abonnements": 112,
				"Conso.": 8119,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1555,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 112,
				"Total": 1667,
				"Economie": 6564,
				"": ""
			},
			{
				"Année": 13,
				"Avant travaux Entretien et Abonnements": 116,
				"Conso.": 8368,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1633,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 116,
				"Total": 1748,
				"Economie": 6735,
				"": ""
			},
			{
				"Année": 14,
				"Avant travaux Entretien et Abonnements": 119,
				"Conso.": 8625,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1714,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 119,
				"Total": 1834,
				"Economie": 6911,
				"": ""
			},
			{
				"Année": 15,
				"Avant travaux Entretien et Abonnements": 123,
				"Conso.": 8890,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1800,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 123,
				"Total": 1923,
				"Economie": 7090,
				"": ""
			},
			{
				"Année": 16,
				"Avant travaux Entretien et Abonnements": 127,
				"Conso.": 9164,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1890,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 127,
				"Total": 2017,
				"Economie": 7274,
				"": ""
			},
			{
				"Année": 17,
				"Avant travaux Entretien et Abonnements": 130,
				"Conso.": 9446,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 1984,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 130,
				"Total": 2115,
				"Economie": 7461,
				"": ""
			},
			{
				"Année": 18,
				"Avant travaux Entretien et Abonnements": 134,
				"Conso.": 9736,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2084,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 134,
				"Total": 2218,
				"Economie": 7653,
				"": ""
			},
			{
				"Année": 19,
				"Avant travaux Entretien et Abonnements": 138,
				"Conso.": 10036,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2188,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 138,
				"Total": 2326,
				"Economie": 7848,
				"": ""
			},
			{
				"Année": 20,
				"Avant travaux Entretien et Abonnements": 142,
				"Conso.": 10346,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2297,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 142,
				"Total": 2440,
				"Economie": 8048,
				"": ""
			},
			{
				"Année": 21,
				"Avant travaux Entretien et Abonnements": 147,
				"Conso.": 10665,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2412,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 147,
				"Total": 2559,
				"Economie": 8252,
				"": ""
			},
			{
				"Année": 22,
				"Avant travaux Entretien et Abonnements": 151,
				"Conso.": 10994,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2533,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 151,
				"Total": 2684,
				"Economie": 8461,
				"": ""
			},
			{
				"Année": 23,
				"Avant travaux Entretien et Abonnements": 156,
				"Conso.": 11333,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2659,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 156,
				"Total": 2815,
				"Economie": 8673,
				"": ""
			},
			{
				"Année": 24,
				"Avant travaux Entretien et Abonnements": 160,
				"Conso.": 11683,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2792,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 160,
				"Total": 2953,
				"Economie": 8890,
				"": ""
			},
			{
				"Année": 25,
				"Avant travaux Entretien et Abonnements": 165,
				"Conso.": 12044,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 2932,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 165,
				"Total": 3097,
				"Economie": 9112,
				"": ""
			},
			{
				"Année": 26,
				"Avant travaux Entretien et Abonnements": 170,
				"Conso.": 12416,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 3079,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 170,
				"Total": 3249,
				"Economie": 9337,
				"": ""
			},
			{
				"Année": 27,
				"Avant travaux Entretien et Abonnements": 175,
				"Conso.": 12800,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 3232,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 175,
				"Total": 3408,
				"Economie": 9568,
				"": ""
			},
			{
				"Année": 28,
				"Avant travaux Entretien et Abonnements": 181,
				"Conso.": 13196,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 3394,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 181,
				"Total": 3575,
				"Economie": 9802,
				"": ""
			},
			{
				"Année": 29,
				"Avant travaux Entretien et Abonnements": 186,
				"Conso.": 13605,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 3564,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 186,
				"Total": 3750,
				"Economie": 10041,
				"": ""
			},
			{
				"Année": 30,
				"Avant travaux Entretien et Abonnements": 192,
				"Conso.": 14026,
				"Investis. Après travaux hors emprunt": 0,
				"Annuité emprunt": 0,
				"Conso. Elec.": 3742,
				"Après travaux Conso. Autre": 0,
				"Entretien et Abonnements": 192,
				"Total": 3933,
				"Economie": 10284,
				"": ""
			}
		],
		"evolutionEmissionGes": {
			"Emission de CO2 avant travaux": "19 928,88 KgCO2éq/an",
			"Emission de CO2 après travaux": " 454,95 KgCO2éq/an",
			"Emission de CO2 des travaux": " 0,00 KgCO2éq/an",
			"Economie réalisée": "584 220 KgéqCo2",
			"tempsPeriode": "sur une période de 30 ans"
		},
		"tempsDeRetour": "entre 2 et 3 ans"
	},
	"recapitulatif": [
		{
			"": "",
			"Intitulé": "Etat initial",
			"Total EPMWh": " 69,2",
			"Total EPkWh/m²": " 532,3",
			"Co2kg/m²": " 153,3",
			"Total?": 5906.2,
			"DifférenceInvestis.": "",
			"Tempsde retour": "",
			"Economie? (%/an)": "0,00 %",
			"EconomieEP (%/an)": "0,00 %",
			"Modif.retenue": ""
		},
		{
			"": "",
			"Intitulé": "SC 1",
			"Total EPMWh": " 15,7",
			"Total EPkWh/m²": " 120,8",
			"Co2kg/m²": " 3,5",
			"Total?": 990.4,
			"DifférenceInvestis.": 11216.8,
			"Tempsde retour": 2.28,
			"Economie? (%/an)": "83,23 %",
			"EconomieEP (%/an)": "77,30 %",
			"Modif.retenue": "Ok"
		},
		{
			"": "",
			"Intitulé": "SC 2",
			"Total EPMWh": " 14,5",
			"Total EPkWh/m²": " 111,9",
			"Co2kg/m²": " 3,2",
			"Total?": 923.3,
			"DifférenceInvestis.": 11216.8,
			"Tempsde retour": 2.25,
			"Economie? (%/an)": "84,37 %",
			"EconomieEP (%/an)": "78,98 %",
			"Modif.retenue": "Ok"
		},
		{
			"": "",
			"Intitulé": "SC 3 BBC",
			"Total EPMWh": " 6,0",
			"Total EPkWh/m²": " 46,0",
			"Co2kg/m²": " 1,2",
			"Total?": 427.5,
			"DifférenceInvestis.": 14483.3,
			"Tempsde retour": 2.64,
			"Economie? (%/an)": "92,76 %",
			"EconomieEP (%/an)": "91,35 %",
			"Modif.retenue": "Ok"
		}
	],
	"restitution": false,
	"date_visite": "11/11/11",
	"date_rapport": "20/11/2023",
	"adresse_front": "9 rue Paul Bert",
	"code_postal_front": "75011",
	"ville_front": "Paris 11",
	"chauffageAppointName": "Cheminée",
	"capRenovVersion": "V2.0.72, 27/06/2023",
	"company": 1,
	"auditeur": "Kuetijo Léa",
	"type_isolation_combles": "Qualité de l'isolation faible moyenne",
	"type_isolation_plancher_bas": "Qualité de l'isolation faible",
	"type_plancher_haut": "Combles aménagés/aménageables",
	"type_plancher_bas": "Garage",
	"cases": [
		{
			"description": "Installation d'un chauffe-eau thermodynamique",
			"price": "€5 000",
			"scenarios": [
				4
			],
			"isKw": [
				1,
				8
			],
			"initialValues": [
				2.7,
				200
			],
			"quantity": 1,
			"infos": "COP ≥ 2,7 - VOLUME >= 200L",
			"COP": 2.7,
			"VOLUME": 200,
			"title": "Chauffe-eau ThermoDynamique (7/55°C)"
		},
		{
			"scenarios": [
				1
			],
			"isKw": [
				0,
				1,
				6
			],
			"initialValues": [
				13,
				4.2,
				126
			],
			"quantity": 1,
			"description": "Installation d'une pompe à chaleur Air/Eau",
			"price": "€17 000",
			"infos": "Puissance = 13kW - COP ≥ 4,2 - ETAS ≥ 126%",
			"PUISSANCE": 13,
			"COP": 4.2,
			"ETAS": 126,
			"title": "PAC Air/Eau Auto-Adaptative (7/35°C)"
		},
		{
			"scenarios": [
				1,
				3
			],
			"isKw": [
				0,
				1,
				6
			],
			"initialValues": [
				13,
				4.2,
				126
			],
			"quantity": 1,
			"description": "Installation d'une pompe à chaleur Air/Eau",
			"price": "€17 000",
			"infos": "Puissance = 13kW - COP ≥ 4,2 - ETAS ≥ 126%",
			"PUISSANCE": 13,
			"COP": 4.2,
			"ETAS": 126,
			"title": "PAC Air/Eau Auto-Adaptative (7/35°C)"
		},
		{
			"description": "Installation d'une pompe à chaleur Air/Air",
			"price": "",
			"scenarios": [],
			"isKw": [
				0,
				1
			],
			"initialValues": [
				null,
				null
			],
			"quantity": 1,
			"infos": "",
			"title": "PAC Air/Air"
		},
		{
			"description": "Installation d'une pompe à chaleur Air/Air MonoSplit",
			"price": "",
			"scenarios": [
				3
			],
			"isKw": [
				0,
				1,
				3
			],
			"initialValues": [
				null,
				null,
				null
			],
			"quantity": 1,
			"infos": "",
			"title": "PAC Air/Air MonoSplit"
		},
		{
			"description": "Installation d'une pompe à chaleur Air/Eau",
			"price": "€17 000",
			"scenarios": [],
			"isKw": [
				0,
				1,
				6
			],
			"initialValues": [
				null,
				null,
				126
			],
			"quantity": 1,
			"infos": "ETAS ≥ 126%",
			"title": "PAC Air/Eau (7/55°C)"
		},
		{
			"description": "",
			"price": "",
			"scenarios": [
				3,
				2
			],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Chauffage bois existant supprimé"
		},
		{
			"description": "",
			"price": "",
			"scenarios": [],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Chauffage bois existant conservé"
		},
		{
			"scenarios": [],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Installation d'une régulation centralisée"
		},
		{
			"description": "Isolation des circuits hydrauliques",
			"price": "€1 200",
			"scenarios": [
				1
			],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Isolation du circuit de distribution"
		},
		{
			"description": "Installation d'un chauffe-eau solaire",
			"price": "€6 500",
			"scenarios": [],
			"isKw": [
				1
			],
			"initialValues": [
				null
			],
			"quantity": 1,
			"infos": "",
			"title": "Chauffe-eau Solaire"
		},
		{
			"description": "R [m².K/W] ≥ 7",
			"price": "45€/m2",
			"scenarios": [],
			"isKw": [
				4
			],
			"initialValues": [
				296.5
			],
			"quantity": 1,
			"M2_A_ISOLER": 296.5,
			"infos": "296,5m² à isoler",
			"title": "Isolation des combles perdus"
		},
		{
			"description": "R [m².K/W] ≥ 6",
			"price": "70€/m2",
			"scenarios": [],
			"isKw": [
				4
			],
			"initialValues": [
				296.5
			],
			"quantity": 1,
			"M2_A_ISOLER": 296.5,
			"infos": "296,5m² à isoler",
			"title": "Isolation des rampants"
		},
		{
			"scenarios": [],
			"isKw": [
				4
			],
			"initialValues": [
				154
			],
			"quantity": 1,
			"M2_A_ISOLER": 154,
			"infos": "154m² à isoler",
			"title": "Isolation du plancher bas sur espace non chauffé"
		},
		{
			"scenarios": [],
			"isKw": [
				4
			],
			"initialValues": [
				202.23000000000002
			],
			"quantity": 1,
			"M2_A_ISOLER": 202.23000000000002,
			"infos": "202,23m² à isoler",
			"title": "Isolation des murs par l'intérieur"
		},
		{
			"scenarios": [],
			"isKw": [
				4
			],
			"initialValues": [
				202.23000000000002
			],
			"quantity": 1,
			"M2_A_ISOLER": 202.23000000000002,
			"infos": "202,23m² à isoler",
			"title": "Isolation des murs par l'extérieur"
		},
		{
			"description": "",
			"price": "€5 000",
			"scenarios": [],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Mise en place d'une VMC double flux"
		},
		{
			"description": "",
			"price": "",
			"scenarios": [],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Poele à granulé"
		},
		{
			"description": "Traitement des points singuliers",
			"price": "",
			"scenarios": [],
			"isKw": [],
			"initialValues": [],
			"quantity": 1,
			"infos": "",
			"title": "Traitement des points singuliers"
		}
	],
	"total_situation_initiale": "66 260",
	"total_scenario_1": "13 720",
	"total_scenario_2": "12 623",
	"total_scenario_3": "4 434",
	"gain_scenario_1": "499,02",
	"gain_scenario_2": "502,29",
	"gain_scenario_3": "526,70",
	"cep_sup_110_scenario_1": "NON",
	"cep_sup_110_scenario_2": "NON",
	"cep_sup_110_scenario_3": "NON",
	"today_date": "20/11/2023",
	"synthese_energetique": "296.5 m2 à isoler",
	"prime_kwh_precaire_scenario_1": "3 503 120,4",
	"prime_kwh_precaire_scenario_2": "3 526 075,8",
	"prime_kwh_precaire_scenario_3": "3 697 434",
	"prime_kwh_classique_scenario_1": "2 984 139,6",
	"prime_kwh_classique_scenario_2": "3 003 694,2",
	"prime_kwh_classique_scenario_3": "3 149 666",
	"prime_bar_precaire_scenario_1": "22 770",
	"prime_bar_precaire_scenario_2": "22 919",
	"prime_bar_precaire_scenario_3": "24 033",
	"prime_bar_classique_scenario_1": "19 397",
	"prime_bar_classique_scenario_2": "19 524",
	"prime_bar_classique_scenario_3": "20 473",
	"prime_cee_scenario_1": "22 770",
	"prime_cee_scenario_2": "22 919",
	"prime_cee_scenario_3": "24 033",
	"situationInitialeEnergieSituationInitiale": "Fioul domestique",
	"situationInitialeEnergieScenario1": "Electricité",
	"situationInitialeEnergieScenario2": "Electricité",
	"situationInitialeEnergieScenario3": "Electricité",
	"situationInitialeEnergieApointSituationInitiale": "Bois dur",
	"situationInitialeEnergieApointScenario1": "",
	"situationInitialeEnergieApointScenario2": "",
	"situationInitialeEnergieApointScenario3": "",
	"situationInitialeEnergieThirdSituationInitiale": "",
	"situationInitialeEnergieThirdScenario1": "",
	"situationInitialeEnergieThirdScenario2": "",
	"situationInitialeEnergieThirdScenario3": "",
	"logiciel": "BAO ÉVOLUTION SED PERRENOUD",
	"methodeDeCalcul": "TH-C-E ex",
	"screenEtatInitialPage": false,
	"screenScenario1Page": false,
	"screenScenario2Page": false,
	"screenScenario3Page": false,
	"pathResolve": "/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/",
	"companyName": "de Prime Évolution",
	"siret": "91948939300018",
	"version": "V2.0.72, 27/06/2023",
	"reference": "LEIWYVMXPV",
	"restitutionArr": [],
	"opqibiFile": "OPQIBI_PRIME_EVO.webp",
	"qaliopi": "<img width=\"85\" height=\"50\" src=\"/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/OPQIBI_PRIME_EVO.webp\" />",
	"coords": "",
	"signature_beneficiaire": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/0f5c180e-97a9-455f-a024-2777857ba349.webp); \" ></div>",
	"address": "",
	"adresse": "9 rue Paul Bert",
	"ville": "Paris 11",
	"code_postal": "75011",
	"full_address": "9 rue Paul Bert, 75011, Paris 11",
	"longitude": 44.487564,
	"latitude": 2.088212,
	"img_location": "<img class=\"image-location\" src=\"/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/fakeBase64Picture.webp\" />",
	"img_streetview": "<img class=\"streetview\" src=\"/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/fakeBase64Picture.webp\" />",
	"auditeurSignature": "KuetijoLéa.webp",
	"signatureAuditor": "<img class=\"image\" src=\"/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/KuetijoLéa.webp\" />",
	"img_streetviewContainer": "<div class=\"align-center\" style=\"flex: 1;\">\n\t<img class=\"streetview\" src=\"/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/fakeBase64Picture.webp\" />\n</div> ",
	"beneficiaire": "FAU PATRICE",
	"topPage1": "<br/>\n<h3 class=\"gradientBg color-white\" style=\"\n    font-weight: 500;\n    display: inline-block;\n    padding: 2px 18px;\n\">SYNTHÈSE DE L'AUDIT ÉNERGETIQUE</h3>\n<br/>",
	"tableRowPage2": "<tr>\n    <td class=\"font-medium align-left\"> Chauffe-eau ThermoDynamique (7/55°C)</td>\n    <td class=\"bg-cell align-center\">COP ≥ 2,7 - VOLUME >= 200L</td>\n    <td class=\"bg-cell align-center\">€5 000</td>\n    <td class=\"bg-cell align-center\">X</td>\n    <td class=\"bg-cell align-center\">X</td>\n    <td class=\"bg-cell align-center\">X</td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> PAC Air/Eau Auto-Adaptative (7/35°C)</td>\n    <td class=\"bg-cell align-center\">Puissance = 13kW - COP ≥ 4,2 - ETAS ≥ 126%</td>\n    <td class=\"bg-cell align-center\">€17 000</td>\n    <td class=\"bg-cell align-center\">X</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> PAC Air/Eau Auto-Adaptative (7/35°C)</td>\n    <td class=\"bg-cell align-center\">Puissance = 13kW - COP ≥ 4,2 - ETAS ≥ 126%</td>\n    <td class=\"bg-cell align-center\">€17 000</td>\n    <td class=\"bg-cell align-center\">X</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\">X</td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> PAC Air/Air</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">€17 000</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> PAC Air/Air MonoSplit</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">€17 000</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\">X</td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> PAC Air/Eau (7/55°C)</td>\n    <td class=\"bg-cell align-center\">ETAS ≥ 126%</td>\n    <td class=\"bg-cell align-center\">€17 000</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Chauffage bois existant supprimé</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\">X</td>\n    <td class=\"bg-cell align-center\">X</td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Chauffage bois existant conservé</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Installation d'une régulation centralisée</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">€400</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Isolation du circuit de distribution</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">€1 200</td>\n    <td class=\"bg-cell align-center\">X</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Chauffe-eau Solaire</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">€6 500</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Isolation des combles perdus</td>\n    <td class=\"bg-cell align-center\">R [m².K/W] ≥ 7</td>\n    <td class=\"bg-cell align-center\">45€/m2</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Isolation des rampants</td>\n    <td class=\"bg-cell align-center\">R [m².K/W] ≥ 6</td>\n    <td class=\"bg-cell align-center\">70€/m2</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Isolation du plancher bas sur espace non chauffé</td>\n    <td class=\"bg-cell align-center\">R [m².K/W] ≥ 3</td>\n    <td class=\"bg-cell align-center\">50€/m2</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Isolation des murs par l'intérieur</td>\n    <td class=\"bg-cell align-center\">R [m².K/W] ≥ 3,7</td>\n    <td class=\"bg-cell align-center\">70€/m2</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Isolation des murs par l'extérieur</td>\n    <td class=\"bg-cell align-center\">R [m².K/W] ≥ 3,7</td>\n    <td class=\"bg-cell align-center\">150€/m2</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Mise en place d'une VMC double flux</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">€5 000</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Poele à granulé</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr><tr>\n    <td class=\"font-medium align-left\"> Traitement des points singuliers</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\">-</td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n    <td class=\"bg-cell align-center\"></td>\n  </tr>",
	"primeAndCostsChauffagesLine": "<tr>\n<th class=\"font-medium align-left\" rowspan=\"2\" colspan=\"1\" scope=\"rowgroup\">Chauffage</th>\n<th  scope=\"row\"  class=\"align-left font-medium\" >Fioul domestique</th>\n<td class=\"bg-cell align-center\">55 877,9</td>\n<td  class=\"align-left font-medium\" >Electricité</td>\n<td class=\"bg-cell align-center\">10 637,9</td>\n<td  class=\"align-left font-medium\" >Electricité</td>\n<td class=\"bg-cell align-center\">9 540,7</td>\n<td  class=\"align-left font-medium\" >Electricité</td>\n<td class=\"bg-cell align-center\">1 352</td>\n</tr>\n<tr>\n<th  scope=\"row\"  class=\"align-left font-medium\" >Bois dur</th>\n<td class=\"bg-cell align-center\">5 892,9</td>\n<td  class=\"align-left font-medium\" ></td>\n<td class=\"bg-cell align-center\">0</td>\n<td  class=\"align-left font-medium\" ></td>\n<td class=\"bg-cell align-center\">0</td>\n<td  class=\"align-left font-medium\" ></td>\n<td class=\"bg-cell align-center\">0</td>\n</tr>",
	"telephone": "-",
	"surface_habitable_audit": "",
	"nb_niveau_maison": "1",
	"systeme_appoint": "Cheminée",
	"emetteur_chauffage": "Chauffage seul Radiateur ancien avec Vanne Th. ",
	"ventilation": "Ouverture des fenêtres",
	"chauffage_audit": "Rendement chaudière = 70%, Absence d'une loi d'eau.",
	"production_ecs": "Lié au chauffage",
	"ouest_mitoyennete": "Non",
	"composition_ouest": "pierres",
	"type_isolation_ouest": "Non isolé",
	"type_volet_ouest": "Double vitrage +10 ans",
	"IMG_OUEST": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/a417e699-f7aa-4094-b842-d18203e17b9d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/842a9ce5-2b3c-4099-86eb-b92dedd90d7c.webp); \" ></div>",
	"est_mitoyennete": "Non",
	"IMG_EST": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/1a448854-b68b-4596-b1f6-828635bf3fce.webp); \" ></div>",
	"composition_est": "pierres",
	"type_isolation_est": "Non isolé",
	"type_volet_est": "",
	"sud_mitoyennete": "Non",
	"IMG_SUD": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/7637a48d-63f1-49a3-be36-c7d39cc1c3f2.webp); \" ></div>",
	"composition_sud": "pierres",
	"type_isolation_sud": "Non isolé",
	"type_volet_sud": "Non isolé",
	"nord_mitoyennete": "Non",
	"IMG_NORD": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/6932fd01-8b34-4337-aa9d-16662abfd3b5.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/28dc956c-cca5-4280-9c86-376d7b0e105b.webp); \" ></div>",
	"composition_nord": "pierres",
	"type_isolation_nord": "Non isolé",
	"type_volet_nord": "Pas de volets",
	"nb_porte_fenetre_nord": "",
	"nb_porte_mesure_nord": "",
	"img_fenetre_nord_1": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/35f091e7-6a1a-409a-8283-557953461ccb.webp); \" ></div>",
	"nb_fenetre_nord_1": "2x0,5x0,5",
	"composition_nord_1": "PVC",
	"vitre_nord_1": "Double vitrage -10 ans",
	"type_volet_nord_1": "Pas de volets",
	"img_fenetre_nord_2": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/be006d26-6168-4fb6-8eba-cba267715fa5.webp); \" ></div>",
	"nb_fenetre_nord_2": "1,5x0,8",
	"composition_nord_2": "PVC",
	"vitre_nord_2": "Double vitrage -10 ans",
	"type_volet_nord_2": "Pas de volets",
	"img_fenetre_nord_3": "",
	"nb_fenetre_nord_3": "",
	"nb_porte_fenetre_sud": "",
	"nb_porte_mesure_sud": "1,94x0,84",
	"img_fenetre_sud_1": "",
	"nb_fenetre_sud_1": "",
	"img_fenetre_sud_2": "",
	"nb_fenetre_sud_2": "",
	"img_fenetre_sud_3": "",
	"nb_fenetre_sud_3": "",
	"nb_porte_fenetre_ouest": "",
	"nb_porte_mesure_ouest": "",
	"img_fenetre_ouest_1": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/279d6cdc-ed2e-4db7-8e93-ff6b20096cc3.webp); \" ></div>",
	"nb_fenetre_ouest_1": "1,56x0,92",
	"composition_ouest_1": "PVC",
	"vitre_ouest_1": "Double vitrage -10 ans",
	"type_volet_ouest_1": "Pas de volets",
	"img_fenetre_ouest_2": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/437a3200-fa64-42b8-a008-09ff50336c79.webp); \" ></div>",
	"nb_fenetre_ouest_2": "1x0,7",
	"composition_ouest_2": "PVC",
	"vitre_ouest_2": "Double vitrage -10 ans",
	"type_volet_ouest_2": "Pas de volets",
	"img_fenetre_ouest_3": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/a167fa83-b55a-4ad8-89d5-85351944f871.webp); \" ></div>",
	"nb_fenetre_ouest_3": "2x1x0,76",
	"composition_ouest_3": "PVC",
	"vitre_ouest_3": "Double vitrage -10 ans",
	"type_volet_ouest_3": "Battants pleins ou volet roulants",
	"nb_porte_fenetre_est": "1,7x1,2 ",
	"nb_porte_mesure_est": "1x0,8",
	"img_fenetre_est_1": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/e70ad339-8c02-4483-b8e9-0684d51b7a4d.webp); \" ></div>",
	"nb_fenetre_est_1": "1,8x0,92",
	"composition_est_1": "PVC",
	"vitre_est_1": "Double vitrage -10 ans",
	"type_volet_est_1": "Battants pleins ou volet roulants",
	"img_fenetre_est_2": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/bc623a30-792f-448a-bd6b-b245a5358aef.webp); \" ></div>",
	"nb_fenetre_est_2": "1,5x1",
	"composition_est_2": "PVC",
	"vitre_est_2": "Double vitrage -10 ans",
	"type_volet_est_2": "Pas de volets",
	"img_fenetre_est_3": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/95fd5e76-6857-42a2-bea5-76367c445df7.webp); \" ></div>",
	"nb_fenetre_est_3": "1x0,7",
	"composition_est_3": "PVC",
	"vitre_est_3": "Double vitrage -10 ans",
	"type_volet_est_3": "Battants pleins ou volet roulants",
	"img_ouvrant_nord": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/35f091e7-6a1a-409a-8283-557953461ccb.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/be006d26-6168-4fb6-8eba-cba267715fa5.webp); \" ></div>",
	"img_ouvrant_sud": "",
	"img_ouvrant_est": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/e70ad339-8c02-4483-b8e9-0684d51b7a4d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/bc623a30-792f-448a-bd6b-b245a5358aef.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/95fd5e76-6857-42a2-bea5-76367c445df7.webp); \" ></div>",
	"img_ouvrant_ouest": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/279d6cdc-ed2e-4db7-8e93-ff6b20096cc3.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/437a3200-fa64-42b8-a008-09ff50336c79.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/a167fa83-b55a-4ad8-89d5-85351944f871.webp); \" ></div>",
	"informations_ouvrant_nord": "<tr>\n            <td class=\"font-medium align-left\">nord</td>\n            <td class=\"bg-cell\">Nombre de fenêtre de type 1: 2x0,5x0,5 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Pas de volets<br><br>Nombre de fenêtre de type 2: 1,5x0,8 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Pas de volets<br><br></td>\n            <td class=\"bg-cell\"><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/35f091e7-6a1a-409a-8283-557953461ccb.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/be006d26-6168-4fb6-8eba-cba267715fa5.webp); \" ></div></td>\n          </tr>",
	"informations_ouvrant_sud": "",
	"informations_ouvrant_ouest": "<tr>\n            <td class=\"font-medium align-left\">ouest</td>\n            <td class=\"bg-cell\">Nombre de fenêtre de type 1: 1,56x0,92 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Pas de volets<br><br>Nombre de fenêtre de type 2: 1x0,7 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Pas de volets<br><br>Nombre de fenêtre de type 3: 2x1x0,76 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Battants pleins ou volet roulants<br><br></td>\n            <td class=\"bg-cell\"><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/279d6cdc-ed2e-4db7-8e93-ff6b20096cc3.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/437a3200-fa64-42b8-a008-09ff50336c79.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/a167fa83-b55a-4ad8-89d5-85351944f871.webp); \" ></div></td>\n          </tr>",
	"informations_ouvrant_est": "<tr>\n            <td class=\"font-medium align-left\">est</td>\n            <td class=\"bg-cell\">Nombre de fenêtre de type 1: 1,8x0,92 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Battants pleins ou volet roulants<br><br>Nombre de fenêtre de type 2: 1,5x1 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Pas de volets<br><br>Nombre de fenêtre de type 3: 1x0,7 <br>\n      Composition: PVC<br>\n      Vitre: Double vitrage -10 ans<br>\n      Type de volet: Battants pleins ou volet roulants<br><br></td>\n            <td class=\"bg-cell\"><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/e70ad339-8c02-4483-b8e9-0684d51b7a4d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/bc623a30-792f-448a-bd6b-b245a5358aef.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/95fd5e76-6857-42a2-bea5-76367c445df7.webp); \" ></div></td>\n          </tr>",
	"type_chauffage": "Fioul",
	"annee_mise_en_oeuvre": "Entre 1989 et 2000",
	"emplacement_chaudiere": "",
	"hauteur_local": "1,99 3,63 3,58",
	"systeme_technique_photos": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/bbac011c-f172-44f5-a555-ff2c752309aa.webp); \" ></div>",
	"compteur_photo": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/123c1390-eef2-4a59-9582-ebeda62019f5.webp); \" ></div>",
	"polarite": "Monophasé",
	"systeme_production_ecs": "<p> Type d'ECS: Lié au chauffage</p>",
	"technique_production_ecs": "",
	"volume_ballon_ecs": "",
	"eau_chaude_sanitaire_photos": "",
	"annee_chauffage_principal": "",
	"systeme_ventilation": "",
	"image_ventilation": "",
	"nombre_salons": "1",
	"m2_salons": "46,30",
	"img_salons": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/8242d3d0-45f1-4473-b41b-413479f28bee.webp); \" ></div>",
	"nombre_chambres": "5",
	"m2_chambres": "ch1/16,52\nch2/18,70\nch3/18,80",
	"nombre_salle_bain": "2",
	"m2_salle_bain": "13,36",
	"garage": "Non",
	"img_garage": "",
	"sous-sol": "cave voutée",
	"img_sous-sol": "",
	"img_radiateur_vanne": "",
	"nb_radiateur_fonte": "",
	"img_radiateur_fonte": "",
	"nb_radiateur_alu": "10",
	"img_radiateur_alu": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/8ed40397-6266-4de2-9b77-2fd9404d3c96.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/4a169564-9236-404c-8c73-50391d8e1028.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/f706995c-1ba5-447a-9257-f44d6755d0f1.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/131e815b-a83b-43fd-a51d-dc77cf4b401c.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/89c99db5-e644-452b-9aa2-d64134a6c9d3.webp); \" ></div>",
	"nb_radiateur_electronique": "0",
	"img_radiateur_electronique": "",
	"croquis_combre": "",
	"croquis_sous": "",
	"croquis_facade_nord": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/96be7a6a-942a-438d-b4e6-b93e18ed4c5b.webp); \" ></div>",
	"croquis_facade_sud": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/563495d8-4d29-4cdb-adbb-9cff91f6017c.webp); \" ></div>",
	"croquis_facade_est": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/26fa359f-244c-4b58-b14a-a8415ea84e00.webp); \" ></div>",
	"croquis_facade_ouest": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/dbfb00e7-8990-49a0-ae63-31b9b8415cde.webp); \" ></div>",
	"croquis_sous-sol": "",
	"croquis_nord": "\n      <tr>\n        <td class=\"font-medium align-left\" >\n          Croquis de la façade nord\n        </td>\n        <td class=\"bg-cell\">\n          <div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/96be7a6a-942a-438d-b4e6-b93e18ed4c5b.webp); \" ></div>\n        </td>\n      </tr>",
	"croquis_sud": "\n      <tr>\n        <td class=\"font-medium align-left\" >\n          Croquis de la façade sud\n        </td>\n        <td class=\"bg-cell\">\n          <div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/563495d8-4d29-4cdb-adbb-9cff91f6017c.webp); \" ></div>\n        </td>\n      </tr>",
	"croquis_est": "\n      <tr>\n        <td class=\"font-medium align-left\" >\n          Croquis de la façade est\n        </td>\n        <td class=\"bg-cell\">\n          <div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/26fa359f-244c-4b58-b14a-a8415ea84e00.webp); \" ></div>\n        </td>\n      </tr>",
	"croquis_ouest": "\n      <tr>\n        <td class=\"font-medium align-left\" >\n          Croquis de la façade ouest\n        </td>\n        <td class=\"bg-cell\">\n          <div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/dbfb00e7-8990-49a0-ae63-31b9b8415cde.webp); \" ></div>\n        </td>\n      </tr>",
	"img_chauffage_appoint": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/82e8adb1-f734-4b00-af88-dbbdc5ea404e.webp); \" ></div>",
	"plancher_chauffant": "Non",
	"plancher_infos": "\n    <tr>\n    <td class=\"font-medium align-left\">Radiateur moyenne température</td>\n    <td class=\"bg-cell align-left\">Chauffage seul Radiateur ancien avec Vanne Th. </td>\n  </tr>",
	"plancher_bas_info": "cave voutée",
	"plancher_bas_garage": "Non",
	"plancher_bas_piece_chauffe": "",
	"plancher_bas_m2": "",
	"plancher_bas_sous_sol_isole": "",
	"plancher_bas_composition_plafond": "",
	"plancher_bas_isolation_1euro": "",
	"plancher_bas_annee_isolant": "",
	"plancher_bas_sous_sol_enterre": "",
	"plancher_bas_vide_sanitaire_hauteur_sous_plafond": "",
	"plancher_bas_vide_sanitaire_longueur_sous_plafond": "",
	"plancher_bas_vide_sanitaire_largeur_sous_plafond": "",
	"plancher_bas_voute_hauteur_sous_plafond": "1,99/2,58/1.99",
	"plancher_bas_voute_longueur_sous_plafond": "9,88/8,32/6,63",
	"plancher_bas_voute_largeur_sous_plafond": "5,53/5,49/3.63",
	"plancher_bas_img_1": "",
	"plancher_bas_img_2": "",
	"plancher_bas_img_3": "",
	"plancher_bas_img_4": "",
	"plancher_bas_img_5": "",
	"plancher_bas_img_6": "",
	"plancher_bas_img_7": "",
	"plancher_bas_img_8": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/ac2ac1d8-97f9-4c7f-808b-afa9433e3b90.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/f885246c-4ae8-41fe-88dc-08435317ecb7.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/549abdba-b7d3-4e02-902a-6a694039011d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/355d7dfb-a0b8-4c9e-90f3-e6329882bb45.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/22aecce6-8d6f-4e31-8856-b927c036d02b.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/77a03b25-0b17-4973-9bde-03a99dd79f24.webp); \" ></div>",
	"plancher_bas_img": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/ac2ac1d8-97f9-4c7f-808b-afa9433e3b90.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/f885246c-4ae8-41fe-88dc-08435317ecb7.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/549abdba-b7d3-4e02-902a-6a694039011d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/355d7dfb-a0b8-4c9e-90f3-e6329882bb45.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/22aecce6-8d6f-4e31-8856-b927c036d02b.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/77a03b25-0b17-4973-9bde-03a99dd79f24.webp); \" ></div>",
	"plancher_bas_voute_vide_sanitaire": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/ac2ac1d8-97f9-4c7f-808b-afa9433e3b90.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/f885246c-4ae8-41fe-88dc-08435317ecb7.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/549abdba-b7d3-4e02-902a-6a694039011d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/355d7dfb-a0b8-4c9e-90f3-e6329882bb45.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/22aecce6-8d6f-4e31-8856-b927c036d02b.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/77a03b25-0b17-4973-9bde-03a99dd79f24.webp); \" ></div>",
	"plancher_haut_info": "cave voutée",
	"plancher_haut_garage": "Non",
	"plancher_haut_piece_chauffe": "",
	"plancher_haut_m2": "",
	"plancher_haut_sous_sol_isole": "",
	"plancher_haut_composition_plafond": "",
	"plancher_haut_isolation_1euro": "",
	"plancher_haut_annee_isolant": "",
	"plancher_haut_sous_sol_enterre": "",
	"plancher_haut_vide_sanitaire_hauteur_sous_plafond": "",
	"plancher_haut_vide_sanitaire_longueur_sous_plafond": "",
	"plancher_haut_vide_sanitaire_largeur_sous_plafond": "",
	"plancher_haut_voute_hauteur_sous_plafond": "1,99/2,58/1.99",
	"plancher_haut_voute_longueur_sous_plafond": "9,88/8,32/6,63",
	"plancher_haut_voute_largeur_sous_plafond": "5,53/5,49/3.63",
	"plancher_haut_img": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/ac2ac1d8-97f9-4c7f-808b-afa9433e3b90.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/f885246c-4ae8-41fe-88dc-08435317ecb7.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/549abdba-b7d3-4e02-902a-6a694039011d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/355d7dfb-a0b8-4c9e-90f3-e6329882bb45.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/22aecce6-8d6f-4e31-8856-b927c036d02b.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/77a03b25-0b17-4973-9bde-03a99dd79f24.webp); \" ></div>",
	"plancher_haut_voute_vide_sanitaire": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/ac2ac1d8-97f9-4c7f-808b-afa9433e3b90.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/f885246c-4ae8-41fe-88dc-08435317ecb7.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/549abdba-b7d3-4e02-902a-6a694039011d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/355d7dfb-a0b8-4c9e-90f3-e6329882bb45.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/22aecce6-8d6f-4e31-8856-b927c036d02b.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/77a03b25-0b17-4973-9bde-03a99dd79f24.webp); \" ></div>",
	"nb_comble": "2",
	"comble_1": "Aménagée/Aménageable",
	"comble_surface_au_sol_1": "115",
	"comble_surface_rampants_1": "166,5",
	"comble_isolation_1": "Non",
	"comble_annee_isolant_1": "+10 ans",
	"comble_type_isolation_1": "Soufflé",
	"comble_img_1": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/b68b1b6d-4587-4d9b-82bc-f10b29a2d100.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/355d1cda-28b7-4d17-8205-4c11766294cd.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/b3980155-343a-4c60-8775-a9b738f2cd21.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/c6e783ba-82ba-440f-a65f-036e9e888f1a.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/b5f0b569-fdf8-44ab-8d70-73ca574f55fa.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/ae664dac-b227-47be-8276-f1c6f0c8ab6d.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/8055a10c-c71f-457f-9251-8065a4b877d1.webp); \" ></div>",
	"comble_2": "Comble Perdu",
	"comble_surface_au_sol_2": "15",
	"comble_surface_rampants_2": "0",
	"comble_isolation_2": "Oui",
	"comble_annee_isolant_2": "",
	"comble_type_isolation_2": "",
	"comble_img_2": "<div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/bcfb267e-954d-4e07-ba92-e5ffba416acc.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/523b7a06-01a3-406c-8a1d-8e4fddc6ca44.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/0c0b700f-0869-413a-a523-39eae72612d1.webp); \" ></div><div class=\"imageCovered squareImageCovered\" style=\"background-image: url(/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/uploads/23910a22-23d9-4f9b-82cc-db84bd250368.webp); \" ></div>",
	"pageNumber8": 8,
	"pageNumber9": 9,
	"pageNumber10": 10,
	"pageNumber11": 11,
	"pageNumber12": 12,
	"pageNumber13": 13,
	"pageNumber14": 14,
	"pageNumber15": 15,
	"pageNumber16": 16,
	"pageNumber17": 17,
	"pageNumber18": 18,
	"pageNumber19": 19,
	"pageNumber20": 20,
	"pageNumber21": 21,
	"pageNumber22": 22,
	"pageNumber23": 23,
	"pageNumber24": 24,
	"pageNumber25": 25,
	"pageNumber26": 26,
	"pageNumber27": 27,
	"pageNumber28": 28,
	"pageNumber29": 29,
	"pageNumber30": 30,
	"pageNumber31": 31,
	"pageNumber32": 32,
	"numero_page_eco_geste": 17,
	"numero_page_aides": 18,
	"numero_page_entretienChauffage": 19,
	"numero_page_glossaire": 20,
	"signature_auditeur": "<img class=\"image\" src=\"/Users/tomktorza/Documents/projet/ASConsulting/ASConsultingBack/src/images/KuetijoLéa.webp\" />"
}